(function () {
  "use strict";

  var root = document.querySelector("[data-drsknn-pricing-v3]");
  if (!root || root.dataset.pricingV3Ready === "true") return;
  root.dataset.pricingV3Ready = "true";
  var bookingFinder = { active: false, suspended: false, overlay: null, options: null, query: "", category: "", area: "", selected: {}, limit: 8, isolation: [], lock: null, opener: null, selectionFocus: null, pushed: false, baseUrl: "", baseState: null };

  var legacyHub = document.querySelector("[data-drsknn-pricing-v3-source] > .drsknn-pricing-hub");
  if (legacyHub) {
    legacyHub.setAttribute("hidden", "");
    legacyHub.setAttribute("aria-hidden", "true");
  }

  var pricingModalBackdrop = document.querySelector("[data-drsknn-pricing-v3-source] .drsknn-pricing-modal-backdrop");
  if (pricingModalBackdrop) pricingModalBackdrop.classList.add("drsknn-pricing-modal-backdrop--pv3");

  function setPricingBookingLayerActive(active) {
    var marker = "drsknn-pricing-booking-open";
    var styleId = "drsknn-pricing-booking-interaction-fix";
    var style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement("style");
      style.id = styleId;
      style.textContent =
        "html." + marker + " #iubenda-cs-banner," +
        "html." + marker + " .iubenda-cs-overlay{" +
        "display:none!important;visibility:hidden!important;pointer-events:none!important}" +
        "html." + marker + " .drsknn-pricing-selection-tray{" +
        "display:none!important;visibility:hidden!important;pointer-events:none!important}" +
        "html." + marker + " .drsknn-pricing-modal-backdrop," +
        "html." + marker + " .drsknn-ui-modal{" +
        "display:none!important;visibility:hidden!important;pointer-events:none!important}" +
        "html." + marker + " [data-drsknn-landing-modal]{" +
        "-webkit-backdrop-filter:none!important;backdrop-filter:none!important;pointer-events:none!important}" +
        "html." + marker + " [data-drsknn-landing-modal-frame]," +
        "html." + marker + " [data-drsknn-landing-modal-close]{" +
        "pointer-events:auto!important}";
      (document.head || document.documentElement).appendChild(style);
    }
    document.documentElement.classList.toggle(marker, Boolean(active));
    if (document.body) document.body.classList.toggle(marker, Boolean(active));
  }

  var pricingBookingModal = document.querySelector("[data-drsknn-landing-modal]");
  function syncContainedBookingLayer() {
    var isPricingBooking =
      pricingBookingModal.classList.contains("is-open") &&
      pricingBookingModal.dataset.pricingV3Trigger === "true";
    setPricingBookingLayerActive(isPricingBooking);
    if (bookingFinder.active && bookingFinder.suspended && !pricingBookingModal.classList.contains("is-open")) {
      // Iframes participate in joint browser history. A history.back() here can
      // navigate only the iframe, without any parent popstate to resume us.
      resumeBookingFinder();
    }
  }
  if (pricingBookingModal && typeof MutationObserver === "function") {
    new MutationObserver(syncContainedBookingLayer).observe(pricingBookingModal, { attributes: true, attributeFilter: ["class", "data-pricing-v3-trigger"] });
  }

  function currentPricingWebsiteReturnUrl() {
    try {
      var returnUrl = new URL(window.location.href);
      if (!/^https:\/\/(?:www\.)?drsknn\.com$/i.test(returnUrl.origin)) return "";
      ["booking_status", "booking_session_id", "paid", "session_id", "canceled"].forEach(function (key) {
        returnUrl.searchParams.delete(key);
      });
      if (!returnUrl.hash && !bookingFinder.active && returnUrl.searchParams.get("open") !== "treatment") returnUrl.hash = "drsknn-home-v2-pricing";
      return returnUrl.toString();
    } catch (_) {
      return "";
    }
  }

  function bookingReturnState() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      var status = String(params.get("booking_status") || "").toLowerCase();
      var sessionId = String(params.get("booking_session_id") || "");
      if (status === "cancelled") return { status: status, sessionId: "" };
      if ((status === "confirmed" || status === "pending") && /^cs_[A-Za-z0-9_]+$/.test(sessionId)) {
        return { status: status, sessionId: sessionId };
      }
    } catch (_) {}
    return { status: "", sessionId: "" };
  }

  function cleanBookingReturnQuery() {
    try {
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("booking_status");
      cleanUrl.searchParams.delete("booking_session_id");
      window.history.replaceState(window.history.state || {}, "", cleanUrl.toString());
    } catch (_) {}
  }

  function renderBookingReturnNotice() {
    var returnState = bookingReturnState();
    if (!returnState.status || document.querySelector("[data-pv3-booking-return]")) return;
    var copy = {
      confirmed: {
        eyebrow: "BOOKING CONFIRMED",
        title: "You’re booked in.",
        body: "Your appointment is confirmed. You are back at the same treatment-pricing page you visited before payment."
      },
      cancelled: {
        eyebrow: "PAYMENT NOT COMPLETED",
        title: "Your visit plan is still here.",
        body: "Nothing has been charged. Your selected treatments have been kept so you can review them or try again."
      },
      pending: {
        eyebrow: "BOOKING UPDATE",
        title: "We’re still confirming your booking.",
        body: "The clinic is checking the payment and appointment status. Please avoid starting a second payment while this completes."
      }
    }[returnState.status];
    if (!copy) return;

    var overlay = document.createElement("div");
    overlay.className = "drsknn-pv3-return-overlay";
    overlay.setAttribute("data-pv3-booking-return", returnState.status);
    overlay.setAttribute("role", "status");
    overlay.setAttribute("aria-live", "polite");
    var notice = document.createElement("section");
    notice.className = "drsknn-pv3-return drsknn-pv3-return--" + returnState.status;
    notice.innerHTML = "<div><span></span><strong></strong><p></p></div><button type=\"button\" aria-label=\"Dismiss booking update\">Dismiss</button>";
    notice.querySelector("span").textContent = copy.eyebrow;
    notice.querySelector("strong").textContent = copy.title;
    notice.querySelector("p").textContent = copy.body;
    notice.querySelector("button").addEventListener("click", function () {
      var restoreExact = overlay.getAttribute("data-pv3-restore-pricing-modal") === "true";
      overlay.remove();
      if (restoreExact && pricingModalBackdrop && pricingModalBackdrop.classList.contains("drsknn-pricing-modal-open")) {
        pricingModalBackdrop.inert = false;
        pricingModalBackdrop.removeAttribute("inert");
        pricingModalBackdrop.setAttribute("aria-hidden", "false");
      }
      cleanBookingReturnQuery();
    });
    overlay.appendChild(notice);
    document.body.appendChild(overlay);
    window.setTimeout(function () {
      overlay.inert = false;
      overlay.removeAttribute("inert");
      overlay.setAttribute("aria-hidden", "false");
      if (pricingModalBackdrop && pricingModalBackdrop.classList.contains("drsknn-pricing-modal-open")) {
        pricingModalBackdrop.inert = true;
        pricingModalBackdrop.setAttribute("aria-hidden", "true");
        overlay.setAttribute("data-pv3-restore-pricing-modal", "true");
      }
      var dismiss = notice.querySelector("button");
      if (dismiss && dismiss.focus) dismiss.focus();
    }, 180);
  }

  function addContainedBookingParams(bookingUrl) {
    var params = {
      embed: "1",
      embedded: "1",
      embedded_pricing: "1",
      hide_cookie_banner: "1",
      hide_cookie_notice: "1",
      hide_iubenda: "1",
      skip_cookie_policy: "1",
      privacy_bypass: "1",
      kiosk_privacy_bypass: "1",
      parent_domain: "drsknn.com",
      website_cookie_consent_status: "handled_on_parent_site",
      website_cookie_consent_ref: "drsknn_com_iubenda"
    };
    Object.keys(params).forEach(function (key) {
      bookingUrl.searchParams.set(key, params[key]);
    });
    var returnUrl = currentPricingWebsiteReturnUrl();
    if (returnUrl) bookingUrl.searchParams.set("return_url", returnUrl);
    if (window.DRSKNN_BOOKING_ENTRY) {
      bookingUrl = new URL(window.DRSKNN_BOOKING_ENTRY.prepareUrl(bookingUrl.toString()));
    }
    return bookingUrl;
  }

  window.openDrSknnContainedBooking = function (url, trigger) {
    var modal = document.querySelector("[data-drsknn-landing-modal]");
    var frame = document.querySelector("[data-drsknn-landing-modal-frame]");
    var close = document.querySelector("[data-drsknn-landing-modal-close]");
    if (!modal || !frame || !url) return false;
    // Treatment V3 renders pricing inside its own modal. Once that parent is
    // closed it becomes visibility:hidden, so a booking modal left inside it
    // can be full-screen yet completely invisible. Move the shared booking
    // layer to body before opening so it is independent of every pricing host.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    try {
      var bookingUrl = new URL(url, window.location.href);
      var isDirectPricingBooking =
        /^https:\/\/(?:www\.)?drsknn\.uk$/i.test(bookingUrl.origin) &&
        bookingUrl.searchParams.get("direct") === "1" &&
        bookingUrl.searchParams.get("booking_mode") === "direct_service" &&
        bookingUrl.searchParams.get("campaign") === "pricing_board" &&
        bookingUrl.searchParams.get("funnel_stage") === "pricing_row_cta";
      var isPricingV3Consultation =
        /^https:\/\/(?:www\.)?drsknn\.uk$/i.test(bookingUrl.origin) &&
        /^\/(?:clinic-)?kiosk$/i.test(bookingUrl.pathname.replace(/\/$/, "")) &&
        bookingUrl.searchParams.get("tab") === "consultations" &&
        bookingUrl.searchParams.get("landing_source") === "drsknn_com_pricing_v3" &&
        bookingUrl.searchParams.get("campaign") === "pricing_v3" &&
        bookingUrl.searchParams.get("landing_page") === "dr_sknn_pricing_v3" &&
        /^pricing_v3_(?:consultation|guided_modal|guidance|multi_treatment)$/.test(
          bookingUrl.searchParams.get("funnel_stage") || ""
        );
      var isPricingV3DirectConsultation =
        /^https:\/\/(?:www\.)?drsknn\.uk$/i.test(bookingUrl.origin) &&
        /^\/kiosk\/v4\/consultation\/(?:doctor|nurse|practitioner)$/i.test(
          bookingUrl.pathname.replace(/\/$/, "")
        ) &&
        bookingUrl.searchParams.get("booking_mode") === "consultation" &&
        bookingUrl.searchParams.get("landing_source") === "drsknn_com_pricing_v3" &&
        bookingUrl.searchParams.get("campaign") === "pricing_v3" &&
        bookingUrl.searchParams.get("landing_page") === "dr_sknn_pricing_v3" &&
        bookingUrl.searchParams.get("funnel_stage") === "pricing_v3_multi_treatment";
      var isPricingVisitConsultation =
        /^https:\/\/(?:www\.)?drsknn\.uk$/i.test(bookingUrl.origin) &&
        bookingUrl.pathname === "/book/visit" &&
        bookingUrl.searchParams.get("booking_mode") === "consultation" &&
        bookingUrl.searchParams.get("booking_route") === "website_consultation_plan";
      var isTreatmentVisitBooking =
        /^https:\/\/(?:www\.)?drsknn\.uk$/i.test(bookingUrl.origin) &&
        bookingUrl.pathname === "/kiosk/book-treatments" &&
        bookingUrl.searchParams.get("booking_route") === "website_treatment_basket";
      var isFinderConsultation = bookingFinder.active &&
        /^https:\/\/(?:www\.)?drsknn\.uk$/i.test(bookingUrl.origin) &&
        ((/^\/(?:clinic-)?kiosk\/?$/i.test(bookingUrl.pathname) && bookingUrl.searchParams.get("tab") === "consultations") ||
          /^\/(?:book\/v4\/consultation(?:\/doctor)?|kiosk\/v4\/consultation\/(?:doctor|nurse|practitioner))\/?$/i.test(bookingUrl.pathname));
      var isPricingBoardConsultation =
        /^https:\/\/(?:www\.)?drsknn\.uk$/i.test(bookingUrl.origin) &&
        /^\/book\/v4\/consultation(?:\/doctor)?\/?$/i.test(bookingUrl.pathname) &&
        bookingUrl.searchParams.get("booking_mode") === "consultation" &&
        bookingUrl.searchParams.get("landing_source") === "drsknn_com_pricing" &&
        bookingUrl.searchParams.get("campaign") === "pricing_board" &&
        bookingUrl.searchParams.get("landing_page") === "pricing" &&
        bookingUrl.searchParams.get("funnel_stage") === "pricing_board_cta";
      if (isPricingVisitConsultation && (
        !window.DRSKNN_BOOKING_PARENT_BRIDGE ||
        typeof window.DRSKNN_BOOKING_PARENT_BRIDGE.register !== "function" ||
        !window.DRSKNN_BOOKING_ENTRY ||
        typeof window.DRSKNN_BOOKING_ENTRY.prepareUrl !== "function"
      )) {
        // A loading/failed parent bridge must not claim iframe ownership.
        // The unchanged standalone route owns its consent and payment return.
        window.location.assign(bookingUrl.toString());
        return true;
      }
      if (
        isDirectPricingBooking ||
        isFinderConsultation ||
        isPricingVisitConsultation ||
        isTreatmentVisitBooking ||
        isPricingV3Consultation ||
        isPricingV3DirectConsultation ||
        isPricingBoardConsultation
      ) {
        bookingUrl = addContainedBookingParams(bookingUrl);
      }
      url = bookingUrl.toString();
    } catch (_) {}
    try {
      if (
        window.DrSknnPricingExperience &&
        typeof window.DrSknnPricingExperience.clearSelection === "function"
      ) {
        window.DrSknnPricingExperience.clearSelection();
      } else {
        document.querySelectorAll(".drsknn-pricing-selection-tray").forEach(function (tray) {
          tray.hidden = true;
        });
      }
    } catch (_) {}
    try {
      var pricingClose = document.querySelector("[data-pricing-close-modal]");
      if (pricingClose) pricingClose.click();
    } catch (_) {}
    if (bookingFinder.active) suspendBookingFinder(trigger);
    frame.removeAttribute("inert");
    modal.inert = false;
    modal.removeAttribute("inert");
    frame.style.pointerEvents = "auto";
    frame.setAttribute("src", url);
    modal.dataset.pricingV3Trigger = trigger ? "true" : "false";
    setPricingBookingLayerActive(Boolean(trigger));
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    if (bookingFinder.active) isolateBookingFinderLayer(modal);
    [document.documentElement, document.body].forEach(function (node) {
      if (!node) return;
      node.dataset.drsknnLandingModalOverflow = node.style.overflow || "";
      node.style.overflow = "hidden";
    });
    if (close && close.focus) close.focus();
    return true;
  };

  window.addEventListener("message", function (event) {
    var modal = document.querySelector("[data-drsknn-landing-modal]");
    var frame = document.querySelector("[data-drsknn-landing-modal-frame]");
    if (!modal || !frame || !event || !event.data) return;
    if (event.data.type !== "drsknn:pricing-booking-back") return;
    if (event.source !== frame.contentWindow) return;
    if (!/^https:\/\/(?:www\.)?drsknn\.uk$/i.test(event.origin || "")) return;
    var close = document.querySelector("[data-drsknn-landing-modal-close]");
    setPricingBookingLayerActive(false);
    if (close && typeof close.click === "function") close.click();
  });

  var treatments = [
    { key: "antiwrinkle", label: "Anti-Wrinkle Injections", description: "Compare package and area prices with Doctor and Nurse options. Treatment is subject to consultation.", areas: ["face", "body"], terms: "anti wrinkle antiwrinkle anti-wrinkle botox lines wrinkles forehead frown crows feet brow bunny nose chin jawline neck sweating hyperhidrosis" },
    { key: "dermalfillers", label: "Dermal fillers", description: "Lips, cheeks, chin, jawline and facial-balancing prices.", areas: ["face"], terms: "filler lip lips cheeks chin jawline tear trough profile balance volume" },
    { key: "prp", label: "PRP", description: "Platelet-rich plasma pricing for skin, body and hair.", areas: ["skin", "face", "body", "hair"], terms: "platelet rich plasma hair growth scalp skin rejuvenation scars stretch marks" },
    { key: "origin", label: "Origin Glass Laser", description: "Laser pricing for eyes, face, neck, body, scars and scalp.", areas: ["skin", "face", "body", "hair"], terms: "glass laser origin eyes neck scars stretch marks scalp acne rejuvenation" },
    { key: "co2", label: "CO2 laser", description: "Fractional resurfacing prices for face and body areas.", areas: ["skin", "face", "body"], terms: "fractional resurfacing scars stretch marks lines wrinkles texture pores laser" },
    { key: "hydrafacial", label: "HydraFacial", description: "Cleansing, hydration and targeted glow programmes.", areas: ["skin", "face"], terms: "facial glow dry dull congested pores hydration acne cleanse" },
    { key: "onda", label: "Body sculpt & contouring", description: "Fat reduction, cellulite reduction, skin tightening and body-contouring prices by treatment area.", areas: ["body"], terms: "onda fat reduction cellulite body contouring sculpt coolwaves laxity skin tightening" },
    { key: "polynucleotide", label: "Polynucleotides", description: "Published polynucleotide options by treatment area.", areas: ["skin", "face"], terms: "pn under eye eyes biostimulation regeneration ageing neck decolletage skin quality" },
    { key: "exosomes", label: "Exosomes", description: "Published exosome-labelled options. Confirm the exact product and proposed use in consultation.", areas: ["skin", "face", "hair"], terms: "exosomes exosome skin hair scalp ageing neck decolletage" },
    { key: "biologicalfiller", label: "Biological filler", description: "Published options listed as biological filler. Discuss the exact preparation and intended use.", areas: ["face"], terms: "biological bio filler volume structure face" },
    { key: "chemicalpeel", label: "Chemical peels", description: "Peel pricing for acne, pigment, texture and glow.", areas: ["skin", "face", "body"], terms: "peel acne pigmentation melasma texture glow pores resurfacing" },
    { key: "hifu", label: "HIFU", description: "Face, neck and body tightening price options.", areas: ["face", "body"], terms: "ultrasound lift lifting tightening laxity jawline neck body" },
    { key: "dermalux", label: "Dermalux LED", description: "Published LED options. Confirm the device and suitability for your concern.", areas: ["skin", "face", "body", "hair"], terms: "dermalux led red blue nir skin face body scalp" },
    { key: "mh10", label: "M-HA 10", description: "Published M-HA 10 options. Confirm the exact product and delivery method.", areas: ["skin", "face"], terms: "mha m-ha 10 skin booster hydration fine lines" },
    { key: "nctf135", label: "NCTF 135 HA", description: "Skin-quality pricing; nurse and qualified-practitioner options are microneedled only.", areas: ["skin", "face"], terms: "nctf mesotherapy microneedling microneedled skin booster glow hydration radiance ageing neck decolletage" },
    { key: "dsmicroneedling", label: "Personalised Dr Sknn Serum Lift", description: "Microneedling and nano-infusion serum programmes.", areas: ["skin", "face", "body", "hair"], terms: "microneedling nano infusion serum lift scars texture pores collagen scalp decolletage" },
    { key: "ipl", label: "IPL / Illumifacial", description: "IPL and Illumifacial pricing for pigment, redness, acne and rejuvenation.", areas: ["skin", "face", "body"], terms: "illumifacial light pigment pigmentation redness rosacea vessels sun damage acne rejuvenation hair" },
    { key: "hairreduction", label: "Hair reduction", description: "Women’s and men’s face and body hair-reduction pricing, organised by area.", areas: ["body", "hair"], terms: "laser unwanted hair face legs underarms bikini back chest men women" },
    { key: "threadingwaxingtinting", label: "Threading, waxing & tinting", description: "Premium face and body waxing, threading and tinting by qualified practitioners.", areas: ["face", "body", "hair"], terms: "eyebrow brows threading waxing tinting upper lip chin jawline nostril ear underarm arms legs bikini shoulders back stomach chest full body grooming" },
    { key: "spmu", label: "SPMU & Lip Blush", description: "Microblading, lip blush and lash-line treatment prices.", areas: ["face", "hair"], terms: "semi permanent makeup spmu microblading eyebrows lip blush eyeliner lash line" }
  ];

  // The public advertising catalogue is selected by the server-rendered template.
  // Every visitor to that URL sees the same available panels and price data.
  if (root.dataset.pricingV3Catalogue === "advertising") {
    treatments = treatments.filter(function (item) {
      return Boolean(document.querySelector('[data-drsknn-pricing-v3-source] [data-price-panel="' + item.key + '"]'));
    });
  }

  var treatmentByKey = treatments.reduce(function (index, item) {
    index[item.key] = item;
    return index;
  }, {});

  var serviceLabelOverrides = {
    "3575459": "Abdomen laser hair reduction",
    "3575470": "Full arms laser hair reduction",
    "3574770": "Full face (PRP)",
    "3574771": "Full face, brow and under-eye (PRP)",
    "3574772": "Full face, brow, under-eye and neck (PRP)",
    "3574773": "Full face (PRP with hyaluronic acid)",
    "3574778": "Brow and under-eye (PRP)",
    "3574780": "Body (PRP with hyaluronic acid) — per vial"
  };

  var areas = [
    { key: "skin", label: "Skin", description: "Acne, pigment, redness, texture or glow" },
    { key: "face", label: "Face", description: "Lines, eyes, volume, lips or profile" },
    { key: "body", label: "Body", description: "Hair, contour, laxity, acne or scarring" },
    { key: "hair", label: "Hair & scalp", description: "Thinning, shedding, scalp or brows" },
    { key: "not-sure", label: "Not sure", description: "Let the clinician guide the starting point" }
  ];

  var concerns = {
    skin: [
      { key: "glow-hydration", label: "Glow, hydration or healthier-looking skin", description: "Dullness, dryness, barrier support and skin quality.", matches: ["hydrafacial", "dermalux", "nctf135", "mh10", "chemicalpeel"] },
      { key: "ageing-collagen", label: "Ageing, hormonal or changing skin", description: "Collagen, elasticity, lines and changing skin quality.", matches: ["polynucleotide", "exosomes", "nctf135", "mh10", "prp", "co2", "origin"] },
      { key: "acne-breakouts", label: "Acne, breakouts or acne marks", description: "Active breakouts, recurring acne and post-acne marks.", matches: ["hydrafacial", "chemicalpeel", "dermalux", "ipl", "dsmicroneedling"] },
      { key: "acne-scars-texture", label: "Acne scarring or uneven texture", description: "Indented scars, roughness, pores and texture change.", matches: ["co2", "origin", "dsmicroneedling", "prp", "chemicalpeel"] },
      { key: "pigmentation-redness", label: "Pigmentation, redness or sun damage", description: "Brown marks, melasma, rosacea, vessels and uneven tone.", matches: ["ipl", "chemicalpeel", "origin", "hydrafacial"] },
      { key: "sensitive-reactive", label: "Sensitive, inflamed or reactive skin", description: "Sensitivity, redness, inflammation and barrier concerns.", matches: ["dermalux", "hydrafacial"] },
      { key: "pores-congestion", label: "Pores, milia or congested skin", description: "Open pores, oiliness, whiteheads and small bumps.", matches: ["hydrafacial", "chemicalpeel", "dsmicroneedling", "co2"] },
      { key: "scars-keloids", label: "Scars, keloids or uneven skin", description: "Non-acne scars, raised scars, texture and colour change.", matches: ["co2", "origin", "prp"] }
    ],
    face: [
      { key: "lines-wrinkles", label: "Lines, wrinkles or collagen change", description: "Movement lines, texture, collagen and skin quality.", matches: ["antiwrinkle", "co2", "origin", "polynucleotide"] },
      { key: "eyes", label: "Tired eyes or under-eyes", description: "Hollows, creasing, dullness and under-eye skin quality.", matches: ["polynucleotide", "nctf135", "dermalfillers", "prp"] },
      { key: "volume-shape", label: "Volume loss or facial shape", description: "Cheeks, structure, proportion and facial balance.", matches: ["dermalfillers", "biologicalfiller", "exosomes"] },
      { key: "jawline-profile", label: "Jawline, chin or profile", description: "Definition, profile balance, lower-face shape and jawline.", matches: ["dermalfillers", "hifu"] },
      { key: "lips", label: "Lips or lip definition", description: "Hydration, volume, shape, outline or longer-lasting colour.", matches: ["dermalfillers", "spmu"] },
      { key: "neck-laxity", label: "Neck or skin laxity", description: "Firmness, creasing, lower-face and neck changes.", matches: ["hifu", "polynucleotide", "co2"] },
      { key: "natural-refresh", label: "A natural-looking refresh", description: "Skin quality, hydration and subtle regenerative routes.", matches: ["hydrafacial", "polynucleotide", "nctf135"] }
    ],
    body: [
      { key: "unwanted-hair", label: "Unwanted face or body hair", description: "Hair-reduction pricing across female and male treatment areas.", matches: ["hairreduction"] },
      { key: "fat-cellulite", label: "Stubborn fat or cellulite", description: "Body contour, cellulite and targeted sculpting concerns.", matches: ["onda"] },
      { key: "laxity-tightening", label: "Loose skin or body tightening", description: "Firmness and laxity across suitable body areas.", matches: ["hifu", "onda", "co2", "origin"] },
      { key: "body-acne", label: "Body acne or breakouts", description: "Breakouts, inflammation and post-acne change on the body.", matches: ["ipl", "chemicalpeel", "dermalux"] },
      { key: "scars-stretchmarks", label: "Scars or stretch marks", description: "Texture, colour change and regenerative scar routes.", matches: ["co2", "origin", "prp", "dsmicroneedling"] },
      { key: "body-pigment", label: "Pigmentation or redness", description: "Uneven tone, pigment and redness on suitable body areas.", matches: ["ipl", "chemicalpeel"] },
      { key: "grooming", label: "Waxing, threading or tinting", description: "Brow, facial-hair and finishing services.", matches: ["threadingwaxingtinting"] }
    ],
    hair: [
      { key: "thinning-shedding", label: "Hair thinning or shedding", description: "Density, shedding and regenerative scalp routes.", matches: ["prp", "exosomes", "dsmicroneedling", "dermalux"] },
      { key: "scalp-health", label: "Scalp health or irritation", description: "Dryness, inflammation and scalp-support routes.", matches: ["prp", "dermalux", "origin"] },
      { key: "hair-unwanted", label: "Unwanted hair", description: "Face and body hair-reduction pricing by area.", matches: ["hairreduction"] },
      { key: "brows-definition", label: "Brows or longer-lasting definition", description: "Microblading, threading, waxing and tinting.", matches: ["spmu", "threadingwaxingtinting"] }
    ],
    "not-sure": [
      { key: "guidance", label: "I would like clinical guidance", description: "Start with a consultation instead of guessing a treatment.", matches: [] }
    ]
  };

  var state = { mode: "help", area: "", concern: "", guideView: "", guideDepth: 0 };
  var rememberedConcerns = {};
  var guideTrigger = null;
  var guideTriggerArea = "";
  var exactSource = "";
  var suppressExactQuerySync = false;
  var areaGrid = root.querySelector("[data-pv3-area-grid]");
  var concernWrap = root.querySelector("[data-pv3-concerns]");
  var concernGrid = root.querySelector("[data-pv3-concern-grid]");
  var concernTitle = root.querySelector("[data-pv3-concern-title]");
  var results = root.querySelector("[data-pv3-results]");
  var resultsGrid = root.querySelector("[data-pv3-results-grid]");
  var resultsTitle = root.querySelector("[data-pv3-results-title]");
  var searchInput = root.querySelector("[data-pv3-search]");
  var searchGrid = root.querySelector("[data-pv3-search-grid]");
  var searchMeta = root.querySelector("[data-pv3-search-meta]");
  var modeButtons = Array.prototype.slice.call(root.querySelectorAll("[data-pv3-mode]"));
  var stages = Array.prototype.slice.call(root.querySelectorAll("[data-pv3-stage]"));
  var guide = root.querySelector("[data-pv3-guide]");
  var guideDialog = root.querySelector(".drsknn-pv3-guide__dialog");
  var guideBody = root.querySelector(".drsknn-pv3-guide__body");
  var guideTitle = root.querySelector("[data-pv3-guide-title]");
  var guideEyebrow = root.querySelector("[data-pv3-guide-eyebrow]");
  var guideAreaCopy = root.querySelector("[data-pv3-guide-area-copy]");
  var guideBackLabel = root.querySelector("[data-pv3-guide-back-label]");
  var guideViews = Array.prototype.slice.call(root.querySelectorAll("[data-pv3-guide-view]"));
  var guideSteps = Array.prototype.slice.call(root.querySelectorAll("[data-pv3-guide-step]"));

  function makeButton(className, label, description, attributes) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = className;
    Object.keys(attributes || {}).forEach(function (name) {
      button.setAttribute(name, attributes[name]);
    });
    var strong = document.createElement("strong");
    strong.textContent = label;
    var span = document.createElement("span");
    span.textContent = description;
    button.appendChild(strong);
    button.appendChild(span);
    return button;
  }

  function setQuery(values, options) {
    try {
      var url = new URL(window.location.href);
      Object.keys(values).forEach(function (key) {
        if (values[key]) url.searchParams.set(key, values[key]);
        else url.searchParams.delete(key);
      });
      var historyState = Object.assign({}, window.history.state || {}, options && options.state ? options.state : {});
      if (options && options.push) window.history.pushState(historyState, "", url.toString());
      else window.history.replaceState(historyState, "", url.toString());
    } catch (_) {}
  }

  function treatmentCard(item, matchLabel) {
    var card = document.createElement("article");
    card.className = "drsknn-pricing-v3__treatment";
    card.setAttribute("data-pv3-treatment", item.key);

    var kicker = document.createElement("span");
    kicker.className = matchLabel ? "drsknn-pricing-v3__match" : "drsknn-pricing-v3__card-kicker";
    kicker.textContent = matchLabel || "Detailed price list";

    var title = document.createElement("h4");
    title.textContent = item.label;
    var copy = document.createElement("p");
    copy.textContent = item.description;
    var button = document.createElement("button");
    button.type = "button";
    button.className = "drsknn-pricing-v3__open";
    button.textContent = "See exact prices";
    button.setAttribute("data-pv3-open", item.key);
    button.setAttribute("aria-label", "See exact " + item.label + " prices");
    if (matchLabel) button.setAttribute("data-pv3-open-source", "guide");

    card.appendChild(kicker);
    card.appendChild(title);
    card.appendChild(copy);
    card.appendChild(button);
    return card;
  }

  function consultationCard() {
    var card = document.createElement("article");
    card.className = "drsknn-pricing-v3__treatment";
    var kicker = document.createElement("span");
    kicker.className = "drsknn-pricing-v3__match";
    kicker.textContent = "Safest starting point";
    var title = document.createElement("h4");
    title.textContent = "Consultation";
    var copy = document.createElement("p");
    copy.textContent = "Let the clinician assess your concern and explain the relevant price lists. Consultation fees are shown before you confirm. Where £50 applies, it is a consultation fee with VAT £0.";
    var link = document.createElement("a");
    link.className = "drsknn-pricing-v3__open";
    link.href = "https://www.drsknn.uk/kiosk?tab=consultations&landing_source=drsknn_com_pricing_v3&campaign=pricing_v3&landing_page=dr_sknn_pricing_v3&funnel_stage=pricing_v3_guidance&embedded_pricing=1";
    link.textContent = "Choose consultation";
    link.setAttribute("data-drsknn-booking-link", "");
    card.appendChild(kicker);
    card.appendChild(title);
    card.appendChild(copy);
    card.appendChild(link);
    return card;
  }

  function renderAreas() {
    areaGrid.textContent = "";
    areas.forEach(function (area) {
      var button = makeButton("drsknn-pricing-v3__choice", area.label, area.description, {
        "data-pv3-area": area.key,
        "aria-pressed": String(state.area === area.key)
      });
      areaGrid.appendChild(button);
    });
  }

  function renderConcerns() {
    var list = concerns[state.area] || [];
    var area = areas.filter(function (item) { return item.key === state.area; })[0];
    concernTitle.textContent = state.area === "not-sure"
      ? "Choose clinical guidance"
      : "Choose the concern that feels closest";
    if (guideAreaCopy) {
      guideAreaCopy.textContent = state.area === "not-sure"
        ? "Choose clinical guidance and the clinic will help you find the safest starting point."
        : "Choose the " + (area ? area.label.toLowerCase() : "") + " concern that feels closest. This matches relevant price lists without diagnosing or choosing treatment for you.";
    }
    concernGrid.textContent = "";
    list.forEach(function (concern) {
      var button = makeButton("drsknn-pricing-v3__concern", concern.label, concern.description, {
        "data-pv3-concern": concern.key,
        "aria-pressed": String(state.concern === concern.key)
      });
      concernGrid.appendChild(button);
    });
    concernWrap.hidden = !list.length;
  }

  function selectedConcern() {
    return (concerns[state.area] || []).filter(function (item) { return item.key === state.concern; })[0] || null;
  }

  function renderResults() {
    var concern = selectedConcern();
    resultsGrid.textContent = "";
    if (!concern) {
      results.hidden = true;
      return;
    }

    if (!concern.matches.length) {
      resultsTitle.textContent = "Start with a consultation";
      resultsGrid.appendChild(consultationCard());
    } else {
      resultsTitle.textContent = "Matched to “" + concern.label + "”";
      concern.matches.forEach(function (key) {
        if (treatmentByKey[key]) resultsGrid.appendChild(treatmentCard(treatmentByKey[key], "Matched to your concern"));
      });
    }
    results.hidden = false;
  }

  function selectedArea() {
    return areas.filter(function (item) { return item.key === state.area; })[0] || null;
  }

  function guideIsOpen() {
    return Boolean(guide && !guide.hidden && guide.getAttribute("aria-hidden") === "false");
  }

  function currentGuideDepth() {
    var depth = window.history.state && Number(window.history.state.pv3GuideDepth);
    return Number.isFinite(depth) && depth >= 0 ? depth : state.guideDepth || 0;
  }

  function recordGuideView(view, push) {
    var nextDepth = push ? currentGuideDepth() + 1 : currentGuideDepth();
    state.guideDepth = nextDepth;
    setQuery({
      price_route: "",
      area: state.area,
      concern: view === "results" ? state.concern : "",
      pricing: ""
    }, {
      push: Boolean(push),
      state: {
        pv3GuideView: view,
        pv3GuideDepth: nextDepth,
        pv3Area: state.area,
        pv3Concern: view === "results" ? state.concern : "",
        pv3ExactSource: ""
      }
    });
  }

  function updateGuideChrome(view) {
    var area = selectedArea();
    var concern = selectedConcern();
    if (view === "results" && concern) {
      guideEyebrow.textContent = (area ? area.label : "Your") + " concern";
      guideTitle.textContent = concern.matches.length ? "Your matched price lists" : "Your clearest next step";
      guideBackLabel.textContent = "Back to concerns";
    } else {
      guideEyebrow.textContent = area ? area.label + " pricing guide" : "Guided pricing";
      guideTitle.textContent = state.area === "not-sure"
        ? "Let the clinic guide your starting point"
        : "What would you like help with for " + (area ? area.label.toLowerCase() : "this area") + "?";
      guideBackLabel.textContent = "Back to page";
    }

    guideSteps.forEach(function (step) {
      var key = step.getAttribute("data-pv3-guide-step");
      step.classList.toggle("is-current", (view === "concerns" && key === "concern") || (view === "results" && key === "matches"));
      step.classList.toggle("is-complete", key === "area" || (view === "results" && key === "concern"));
      if (step.classList.contains("is-current")) step.setAttribute("aria-current", "step");
      else step.removeAttribute("aria-current");
    });
  }

  function showGuideView(view, options) {
    state.guideView = view === "results" ? "results" : "concerns";
    guideViews.forEach(function (panel) {
      panel.hidden = panel.getAttribute("data-pv3-guide-view") !== state.guideView;
    });
    updateGuideChrome(state.guideView);
    if (guideBody) guideBody.scrollTop = 0;
    if (!options || options.focus !== false) {
      window.setTimeout(function () {
        if (guideDialog && guideIsOpen()) guideDialog.focus();
      }, 0);
    }
  }

  function openGuide(view, trigger, options) {
    if (!guide || !guideDialog) return;
    if (trigger) guideTrigger = trigger;
    guide.hidden = false;
    guide.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("drsknn-pv3-guide-open");
    if (document.body) document.body.classList.add("drsknn-pv3-guide-open");
    showGuideView(view, options);
  }

  function hideGuide(options) {
    if (!guide) return;
    guide.hidden = true;
    guide.setAttribute("aria-hidden", "true");
    state.guideView = "";
    document.documentElement.classList.remove("drsknn-pv3-guide-open");
    if (document.body) document.body.classList.remove("drsknn-pv3-guide-open");
    var restoredTrigger = guideTriggerArea
      ? areaGrid.querySelector('[data-pv3-area="' + guideTriggerArea + '"]')
      : guideTrigger;
    if ((!options || options.restoreFocus !== false) && restoredTrigger && typeof restoredTrigger.focus === "function") {
      window.setTimeout(function () { restoredTrigger.focus(); }, 0);
    }
  }

  function closeGuide() {
    var depth = currentGuideDepth();
    if (depth > 0) {
      window.history.go(depth * -1);
      return;
    }
    hideGuide();
    state.area = "";
    state.concern = "";
    state.guideDepth = 0;
    renderAreas();
    renderConcerns();
    renderResults();
    setQuery({ area: "", concern: "", pricing: "" }, {
      state: { pv3GuideView: "base", pv3GuideDepth: 0, pv3Area: "", pv3Concern: "" }
    });
  }

  function guideFocusables() {
    if (!guide) return [];
    return Array.prototype.slice.call(guide.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return !element.hidden && element.getClientRects().length > 0;
    });
  }

  function handleGuideKeydown(event) {
    if (!guideIsOpen()) return;
    if (event.key === "Escape") {
      event.preventDefault();
      closeGuide();
      return;
    }
    if (event.key !== "Tab") return;
    var focusable = guideFocusables();
    if (!focusable.length) {
      event.preventDefault();
      guideDialog.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function normalize(value) {
    var normalized = String(value || "");
    if (typeof normalized.normalize === "function") {
      normalized = normalized.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
    }
    return normalized.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  }

  function searchScore(item, query) {
    if (!query) return 1;
    var terms = normalize(item.label + " " + item.description + " " + item.terms + " " + item.areas.join(" "));
    var words = normalize(query).split(/\s+/).filter(Boolean);
    var score = 0;
    words.forEach(function (word) {
      if (normalize(item.label).indexOf(word) !== -1) score += 8;
      else if (terms.indexOf(word) !== -1) score += 3;
    });
    return words.length && score >= words.length * 3 ? score : 0;
  }

  function renderSearch(query) {
    var ranked = treatments.map(function (item, index) {
      return { item: item, index: index, score: searchScore(item, query) };
    }).filter(function (entry) {
      return entry.score > 0;
    }).sort(function (a, b) {
      return b.score - a.score || a.index - b.index;
    });

    searchGrid.textContent = "";
    ranked.forEach(function (entry) { searchGrid.appendChild(treatmentCard(entry.item, "")); });
    if (!ranked.length) {
      var empty = document.createElement("div");
      empty.className = "drsknn-pricing-v3__empty";
      empty.textContent = "No exact match yet. Try the concern finder or choose a consultation.";
      searchGrid.appendChild(empty);
    }
    searchMeta.textContent = ranked.length + (ranked.length === 1 ? " treatment price list" : " treatment price lists") + (query ? " matched" : "");
  }

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function normalizePriceLabel(value) {
    var label = cleanText(value).replace(/[:：]+$/, "");
    var normalized = normalize(label);
    if (!normalized || normalized === "price" || normalized === "investment") return "Price";
    if (normalized === "pay as you go" || normalized === "single per 1ml" || normalized === "single treatment") return "Single";
    if (normalized === "single") return "Single";
    if (normalized === "subscription") return "Subscription";
    if (normalized === "time" || normalized === "treatment time") return "Duration";
    if (normalized.indexOf("course") !== -1) return label.replace(/\bof\b/i, "of");
    return label.replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function roleLabel(role) {
    var normalized = String(role || "").toLowerCase();
    if (normalized === "doctor") return "Doctor";
    if (normalized === "nurse") return "Nurse";
    if (normalized === "qualified_practitioner") return "Qualified practitioner";
    if (normalized === "nurse_qualified_practitioner") return "Nurse or qualified practitioner";
    if (normalized === "any_practitioner") return "Any suitable clinician";
    return "Dr Sknn clinician";
  }

  function inferredRole(row, key) {
    var node = row;
    var context = "";
    while (node) {
      context += " " + String(node.id || "") + " " + String(node.className || "");
      if (node.matches && node.matches("[data-price-panel]")) break;
      node = node.parentElement;
    }
    context = context.toLowerCase();
    if (context.indexOf("nurse") !== -1) return "nurse";
    if (context.indexOf("doctor") !== -1) return "doctor";
    if (context.indexOf("practitioner") !== -1) return "qualified_practitioner";
    if (key === "dermalux") return "qualified_practitioner";
    if (key === "ipl") return "nurse_qualified_practitioner";
    return "any_practitioner";
  }

  function pricingAudience(row, key) {
    if (key !== "hairreduction" || !row || !row.closest) return "";
    if (row.closest(".sknn-ipl-price-card--women")) return "Women";
    if (row.closest(".sknn-ipl-price-card--men")) return "Men";
    return "";
  }

  function consultationPolicyForOption(option) {
    // Origin always starts with a doctor. Anti-wrinkle follows the selected
    // clinician; the server verifies that role against the canonical service.
    if (option && option.catalogueKey === "origin") return { role: "doctor", label: "Doctor consultation", mode: "consultation" };
    if (option && option.catalogueKey === "antiwrinkle") {
      var role = visitInterestRole(option.role) === "nurse" ? "nurse" : "doctor";
      return { role: role, label: roleLabel(role) + " consultation", mode: "consultation" };
    }
    return null;
  }

  function displayedRoleLabel(option) {
    if (option.catalogueKey === "antiwrinkle") return roleLabel(option.role) + " treatment price";
    var policy = consultationPolicyForOption(option);
    if (policy) return policy.label;
    var label = roleLabel(option.role);
    if (
      option.catalogueKey === "nctf135" &&
      (option.role === "nurse" ||
        option.role === "qualified_practitioner" ||
        option.role === "nurse_qualified_practitioner")
    ) {
      return label + " · Microneedled only";
    }
    return label;
  }

  function tableHeaders(table) {
    var headerRow = table.querySelector("thead tr:last-child");
    return headerRow ? Array.prototype.map.call(headerRow.children, function (cell) { return cleanText(cell.textContent); }) : [];
  }

  function roleHeaderMatches(label, role) {
    var normalized = normalize(label);
    if (role === "doctor") return normalized.indexOf("doctor") !== -1;
    if (role === "nurse") return normalized === "nurse" || normalized.indexOf("nurse price") !== -1;
    if (role === "qualified_practitioner") return normalized.indexOf("qualified practitioner") !== -1 || normalized === "practitioner";
    if (role === "nurse_qualified_practitioner") return normalized.indexOf("nurse") !== -1 || normalized.indexOf("practitioner") !== -1;
    return false;
  }

  function rowPriceEntries(row, headers, role) {
    var cells = Array.prototype.slice.call(row.children);
    var roleColumns = headers.map(function (header, index) {
      return roleHeaderMatches(header, role) ? index : -1;
    }).filter(function (index) { return index > 0; });
    var providerMatrix = headers.some(function (header) { return roleHeaderMatches(header, "doctor") || roleHeaderMatches(header, "nurse") || roleHeaderMatches(header, "qualified_practitioner"); });
    var entries = [];

    cells.slice(1).forEach(function (cell, offset) {
      var index = offset + 1;
      var value = cleanText(cell.textContent);
      var header = headers[index] || cell.getAttribute("data-mobile-label") || "Price";
      var normalizedHeader = normalize(header);
      if (!value || normalizedHeader === "choose" || normalizedHeader === "book" || cell.querySelector("[data-drsknn-pricing-service-id]")) return;
      if (providerMatrix && roleColumns.length && roleColumns.indexOf(index) === -1) return;
      if (!/£\s?[\d,]+(?:\.\d{1,2})?/.test(value) && normalizedHeader.indexOf("time") === -1 && normalizedHeader.indexOf("duration") === -1) return;
      entries.push({
        label: providerMatrix && roleColumns.length ? "Price" : normalizePriceLabel(header),
        value: value
      });
    });

    return entries.filter(function (entry, index) {
      return entries.findIndex(function (candidate) { return candidate.label === entry.label && candidate.value === entry.value; }) === index;
    });
  }

  // Booking uses the same exact options and links as the price catalogue. The
  // homepage loader may have parked the source panels inside a template cache.
  function bookingFinderOptions() {
    if (bookingFinder.options) return bookingFinder.options;
    var seen = new Set();
    var options = [];
    treatments.forEach(function (item) {
      var panel = document.querySelector('[data-price-panel="' + item.key + '"]');
      if (!panel && window.DrSknnHomepageV2Performance && typeof window.DrSknnHomepageV2Performance.findPricingPanel === "function") panel = window.DrSknnHomepageV2Performance.findPricingPanel(item.key);
      if (!panel) return;
      collectCatalogueOptions(panel, item.key).forEach(function (option) {
        if (!option.direct || !option.link || seen.has(option.serviceId)) return;
        seen.add(option.serviceId);
        option.catalogueKey = item.key;
        option.categoryLabel = item.label;
        option.categoryTerms = item.terms;
        options.push(option);
      });
    });
    // An empty lazy-load result must be retryable, not cached for the session.
    if (options.length) bookingFinder.options = options;
    return options;
  }

  function bookingOptionScore(option, query) {
    var words = normalize(query).split(/\s+/).filter(Boolean);
    if (!words.length) return 1;
    var title = normalize(option.title + " " + (option.sourceTitle || ""));
    var context = normalize((bookingFinder.category ? "" : option.categoryLabel + " " + option.catalogueKey + " " + (option.catalogueKey === "antiwrinkle" ? "anti wrinkle antiwrinkle botox lines wrinkles" : "") + " " + ({prp: "platelet rich plasma", polynucleotide: "pn", onda: "coolwaves", dsmicroneedling: "microneedling nano infusion", nctf135: "mesotherapy", mh10: "mha", spmu: "semi permanent makeup microblading"}[option.catalogueKey] || "")) + " " + displayedRoleLabel(option) + " " + (option.audience || ""));
    if (!words.every(function (word) { return title.indexOf(word) !== -1 || context.indexOf(word) !== -1; })) return 0;
    return words.reduce(function (score, word) { return score + (title.indexOf(word) !== -1 ? 10 : 1); }, title.indexOf(normalize(query)) !== -1 ? 20 : 0);
  }

  function bookingSinglePrice(option) {
    // Never advertise a subscription/course amount as the single appointment price.
    return (option.prices || []).find(function (entry) {
      return /^(single|price|pay as you go)\b/.test(normalize(entry.label)) && /£/.test(entry.value) && !/(subscription|course|monthly|per month|\/\s*mo(?:nth)?\b)/i.test(entry.value);
    }) || null;
  }

  // A card represents one exact treatment scope, with clinician alternatives inside.
  function antiwrinklePackageRank(option) {
    if (!option || option.catalogueKey !== "antiwrinkle") return 2;
    var value = normalize(option.sourceTitle || option.title);
    if (/^(?:3|three) (?:classic )?areas?$/.test(value)) return 0;
    if (/^(?:2|two) (?:classic )?areas?$/.test(value)) return 1;
    return 2;
  }

  function antiwrinkleFamilyKey(option) {
    var families = {"3574409":"3574409","3574430":"3574409","3574408":"3574408","3574429":"3574408","3574389":"3574389","3574414":"3574389","3574386":"3574386","3574413":"3574386","3574401":"3574401","3574422":"3574401","3574385":"3574385","3574412":"3574385","3574402":"3574402","3574423":"3574402","3574383":"3574383","3574410":"3574383","3574384":"3574384","3574411":"3574384","3574397":"3574397","3574407":"3574407","3574428":"3574407","3574400":"3574400","3574421":"3574400","3574398":"3574398","3574419":"3574398","3574399":"3574399","3574420":"3574399","3574391":"3574391","3574416":"3574391","3574390":"3574390","3574415":"3574390","3574403":"3574403","3574424":"3574403","3574404":"3574404","3574425":"3574404","3574405":"3574405","3574426":"3574405","3574406":"3574406","3574427":"3574406","3574396":"3574396"};
    return families[option.serviceId] || normalize(option.sourceTitle || option.title);
  }

  function bookingTreatmentKey(option) {
    if (option.catalogueKey === "antiwrinkle") return "antiwrinkle|" + antiwrinkleFamilyKey(option);
    var fillerFamilies = { '3575640': '3575626', '3575641': '3575627', '3575642': '3575628', '3575643': '3575629', '3575644': '3575630', '3575645': '3575631', '3575646': '3575632' };
    if (option.catalogueKey === "dermalfillers") return "dermalfillers|" + (fillerFamilies[option.serviceId] || option.serviceId);
    return [option.catalogueKey, option.audience || "", option.catalogueKey === "nctf135" ? (option.role === "doctor" ? "injectable" : "microneedled") : "", normalize(option.sourceTitle || option.title)].join("|");
  }

  function bookingTreatmentGroups(options, query) {
    var groups = new Map();
    options.forEach(function (option, index) {
      var key = bookingTreatmentKey(option);
      if (!groups.has(key)) groups.set(key, { key: key, options: [], index: index, score: 0 });
      var group = groups.get(key);
      group.options.push(option);
      group.score = Math.max(group.score, bookingOptionScore(option, query));
    });
    return Array.from(groups.values()).filter(function (group) { return group.score > 0; }).map(function (group) {
      group.options.sort(function (a, b) { return rolePriority(a.role) - rolePriority(b.role); });
      var remembered = bookingFinder.selected[group.key];
      group.option = group.options.find(function (option) { return option.serviceId === remembered; }) || group.options[0];
      return group;
    }).sort(function (a, b) {
      return (a.options[0].catalogueKey === "antiwrinkle" && b.options[0].catalogueKey === "antiwrinkle" ? antiwrinklePackageRank(a.options[0]) - antiwrinklePackageRank(b.options[0]) : 0) || b.score - a.score || rolePriority(a.options[0].role) - rolePriority(b.options[0].role) || a.index - b.index;
    });
  }

  function bookingOptionRow(group) {
    var option = group.option;
    var policy = consultationPolicyForOption(option);
    var row = document.createElement("article");
    row.className = "drsknn-booking-finder__row";
    row.setAttribute("data-booking-option", option.serviceId);
    var copy = document.createElement("div");
    copy.className = "drsknn-booking-finder__copy";
    var heading = document.createElement("h3");
    heading.textContent = option.title;
    var provider = document.createElement("p");
    provider.className = "drsknn-booking-finder__provider";
    provider.textContent = option.categoryLabel + " · " + displayedRoleLabel(option) + (option.audience ? " · " + option.audience : "");
    var price = document.createElement("p");
    price.className = "drsknn-booking-finder__price";
    var single = bookingSinglePrice(option);
    price.textContent = single ? (policy ? "Treatment guide: " : "") + single.value : "Price confirmed before payment";
    copy.appendChild(heading); copy.appendChild(provider); copy.appendChild(price);
    if (policy) {
      var note = document.createElement("p");
      note.className = "drsknn-booking-finder__provider";
      note.textContent = "Starts with a " + policy.role + " consultation. Reservation details are shown before confirmation.";
      copy.appendChild(note);
    }
    var about = document.createElement("details");
    about.className = "drsknn-booking-finder__about";
    var aboutSummary = document.createElement("summary");
    aboutSummary.setAttribute("aria-label", "About this treatment: " + option.title);
    aboutSummary.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg><span>About this treatment</span><span class="drsknn-booking-finder__about-toggle" aria-hidden="true"></span>';
    var explanation = document.createElement("p");
    explanation.textContent = treatmentExplanation(option);
    about.appendChild(aboutSummary); about.appendChild(explanation); copy.appendChild(about);
    if (group.options.length > 1) {
      var alternatives = document.createElement("details");
      alternatives.className = "drsknn-booking-finder__providers";
      var summary = document.createElement("summary");
      summary.textContent = "Other clinicians and prices";
      alternatives.appendChild(summary);
      group.options.forEach(function (candidate) {
        var button = document.createElement("button");
        button.type = "button"; button.className = "drsknn-booking-finder__provider-option";
        button.setAttribute("data-booking-provider", candidate.serviceId);
        button.setAttribute("data-booking-group", group.key);
        button.setAttribute("aria-pressed", String(candidate.serviceId === option.serviceId));
        var label = document.createElement("strong"); label.textContent = displayedRoleLabel(candidate);
        var value = document.createElement("span"); var candidatePrice = bookingSinglePrice(candidate);
        value.textContent = candidatePrice ? candidatePrice.value : "Price on request";
        button.appendChild(label); button.appendChild(value);
        if (candidate.title !== option.title) { var scope = document.createElement("small"); scope.textContent = candidate.title; button.appendChild(scope); }
        alternatives.appendChild(button);
      });
      copy.appendChild(alternatives);
    }
    var actions = document.createElement("div"); actions.className = "drsknn-booking-finder__actions";
    var book = copyServiceLink(option.link, option.title);
    book.className = "drsknn-booking-finder__book";
    book.textContent = policy ? "Book " + policy.role + " consultation" : "Choose time";
    book.removeAttribute("role"); book.removeAttribute("aria-pressed");
    book.setAttribute("aria-label", (policy ? "Book " + policy.role + " consultation for " : "Choose time for ") + option.title + (policy ? "" : " with " + displayedRoleLabel(option)));
    var add = document.createElement("button"); add.type = "button"; add.className = "drsknn-booking-finder__add";
    add.textContent = "+ Add to my visit";
    add.setAttribute("data-pv3-add-visit", JSON.stringify(visitSelectionFromOption(option)));
    actions.appendChild(book); actions.appendChild(add); row.appendChild(copy); row.appendChild(actions);
    return row;
  }



  function renderBookingFinder() {
    var overlay = bookingFinder.overlay;
    if (!overlay) return;
    var query = bookingFinder.query;
    var category = bookingFinder.category;
    var list = overlay.querySelector("[data-booking-results]");
    var choices = overlay.querySelector("[data-booking-categories]");
    var areaTiles = overlay.querySelector("[data-booking-areas]");
    var scoped = bookingFinderOptions().filter(function (option) { return !category || option.catalogueKey === category; });
    var allGroups = bookingTreatmentGroups(scoped, "");
    var areas = category ? groupedCatalogueOptions(scoped, category) : [];
    var useAreas = category && allGroups.length > 8 && areas.length > 1;
    var choosingArea = useAreas && !bookingFinder.area && !query.trim();
    var searching = Boolean(query.trim() || category);
    choices.hidden = searching; areaTiles.hidden = !choosingArea; areaTiles.textContent = "";
    overlay.querySelector("[data-booking-all]").hidden = !searching;
    overlay.querySelector("[data-booking-areas-back]").hidden = !useAreas || (!bookingFinder.area && !query.trim());
    if (choosingArea) areas.forEach(function (area) {
      var button = document.createElement("button"); button.type = "button";
      button.setAttribute("data-booking-area", area.label);
      var label = document.createElement("strong"); label.textContent = area.label;
      var count = document.createElement("span"); var countValue = bookingTreatmentGroups(area.options, "").length;
      count.textContent = countValue + (countValue === 1 ? " option" : " options");
      button.appendChild(label); button.appendChild(count); areaTiles.appendChild(button);
    });
    if (bookingFinder.area) scoped = scoped.filter(function (option) { return areaGroupForOption(option, category) === bookingFinder.area; });
    var groups = bookingTreatmentGroups(scoped, query);
    list.textContent = "";
    var showPackages = category === "antiwrinkle" && choosingArea;
    // Packages are visible immediately; remaining areas stay one click away.
    if (showPackages) bookingTreatmentGroups(scoped.filter(function (option) { return antiwrinklePackageRank(option) < 2; }), "").forEach(function (group) { list.appendChild(bookingOptionRow(group)); });
    if (searching && !choosingArea) groups.slice(0, bookingFinder.limit).forEach(function (group) { list.appendChild(bookingOptionRow(group)); });
    if (showPackages) list.parentNode.insertBefore(list, areaTiles);
    else areaTiles.parentNode.insertBefore(areaTiles, list);
    var meta = overlay.querySelector("[data-booking-result-count]");
    meta.textContent = category ? treatmentByKey[category].label + (bookingFinder.area ? " · " + bookingFinder.area : "") : (searching ? "All treatments" : "Choose a treatment category or search by name.");
    var scope = overlay.querySelector("[data-booking-scope]"); scope.hidden = !searching;
    scope.textContent = choosingArea ? "Choose an area to see the relevant options." : groups.length + (groups.length === 1 ? " treatment choice" : " treatment choices") + ". Doctor prices are shown first where available.";
    if (category === "antiwrinkle") scope.textContent = "Compare Doctor and Nurse treatment prices. Booking starts with your selected clinician’s consultation; treatment is subject to assessment.";
    if (category === "origin") scope.textContent = choosingArea ? "Every Origin visit starts with a doctor consultation. Choose the area you want to discuss." : "Every Origin visit starts with a doctor consultation. Add areas to discuss together, or book your consultation now.";
    var search = overlay.querySelector("[data-booking-search]");
    search.placeholder = category ? "Search within " + treatmentByKey[category].label + "…" : "Try HydraFacial, lips or laser…";
    overlay.querySelector('label[for="drsknn-booking-finder-search"]').textContent = category ? "Search " + treatmentByKey[category].label : "Search treatments";
    if (searching && !groups.length && !choosingArea) {
      var empty = document.createElement("p");
      empty.className = "drsknn-booking-finder__empty";
      empty.textContent = category && allGroups.length ? "No matching option. Try a shorter name or choose another area." : category ? "Online treatment times aren’t listed for this category. Book a consultation for help choosing." : "No matching treatment found. Try a shorter name, such as lips, facial or laser, or browse all categories.";
      list.appendChild(empty);
      if (category && !allGroups.length) {
        var consultation = document.createElement("button");
        consultation.type = "button";
        consultation.className = "drsknn-booking-finder__book";
        consultation.textContent = "Book a consultation";
        consultation.setAttribute("data-booking-consultation", category);
        list.appendChild(consultation);
      }
      if (!category && query.trim()) treatments.forEach(function (item) {
        if (!searchScore(item, query) || bookingFinderOptions().some(function (option) { return option.catalogueKey === item.key; })) return;
        var guidance = document.createElement("button");
        guidance.type = "button";
        guidance.className = "drsknn-booking-finder__more";
        guidance.textContent = item.label + " · Book a consultation";
        guidance.setAttribute("data-booking-consultation", item.key);
        list.appendChild(guidance);
      });
    }
    overlay.querySelector("[data-booking-more]").hidden = !searching || choosingArea || groups.length <= bookingFinder.limit;
    renderVisitBasket(false);
  }

  function ensureBookingFinder() {
    if (bookingFinder.overlay) return bookingFinder.overlay;
    var overlay = document.createElement("div"); overlay.className = "drsknn-booking-finder"; overlay.hidden = true;
    overlay.innerHTML = '<section class="drsknn-booking-finder__dialog" role="dialog" aria-modal="true" aria-labelledby="drsknn-booking-finder-title" tabindex="-1">' +
      '<header><div><h2 id="drsknn-booking-finder-title">Book a treatment</h2><p>Find your area, review the price and choose your next step.</p></div><button type="button" data-booking-finder-close aria-label="Close treatment finder">×</button></header>' +
      '<div class="drsknn-booking-finder__controls"><label for="drsknn-booking-finder-search">Search treatments</label><input id="drsknn-booking-finder-search" type="search" autocomplete="off" placeholder="Try HydraFacial, lips or laser…" data-booking-search><div class="drsknn-booking-finder__navigation"><button type="button" data-booking-all hidden>← All treatments</button><button type="button" data-booking-areas-back hidden>← All areas</button><p data-booking-result-count role="status" aria-live="polite"></p></div></div>' +
      '<div class="drsknn-booking-finder__body" data-booking-scroll><div class="drsknn-booking-finder__categories" data-booking-categories></div><p class="drsknn-booking-finder__scope" data-booking-scope role="status" aria-live="polite" aria-atomic="true" hidden></p><div class="drsknn-booking-finder__areas" data-booking-areas hidden></div><div data-booking-results></div><button type="button" class="drsknn-booking-finder__more" data-booking-more hidden>Show more options</button></div>' +
      '<footer>Add selections to My visit to discuss them together in a consultation.</footer></section>';
    document.body.appendChild(overlay); bookingFinder.overlay = overlay;
    var categories = overlay.querySelector("[data-booking-categories]");
    treatments.forEach(function (item) { var button = document.createElement("button"); button.type = "button"; button.textContent = item.label; button.setAttribute("data-booking-category", item.key); categories.appendChild(button); });
    overlay.querySelector("[data-booking-search]").addEventListener("input", function (event) {
      bookingFinder.query = event.target.value; bookingFinder.limit = 8; renderBookingFinder(); overlay.querySelector("[data-booking-scroll]").scrollTop = 0;
    });
    overlay.addEventListener("click", function (event) {
      if (event.target === overlay || event.target.closest("[data-booking-finder-close]")) { closeBookingFinder(); return; }
      var provider = event.target.closest("[data-booking-provider]");
      if (provider) {
        bookingFinder.selected[provider.getAttribute("data-booking-group")] = provider.getAttribute("data-booking-provider");
        var id = provider.getAttribute("data-booking-provider"); renderBookingFinder();
        var card = Array.prototype.find.call(overlay.querySelectorAll("[data-booking-option]"), function (node) { return node.getAttribute("data-booking-option") === id; });
        if (card) card.querySelector(".drsknn-booking-finder__providers > summary").focus({preventScroll:true}); return;
      }
      var category = event.target.closest("[data-booking-category]");
      var all = event.target.closest("[data-booking-all]"); var area = event.target.closest("[data-booking-area]"); var areasBack = event.target.closest("[data-booking-areas-back]");
      if (category || all || area || areasBack) {
        if (category || all) { bookingFinder.category = category ? category.getAttribute("data-booking-category") : ""; bookingFinder.area = ""; }
        if (area || areasBack) bookingFinder.area = area ? area.getAttribute("data-booking-area") : "";
        bookingFinder.query = ""; bookingFinder.limit = 8; overlay.querySelector("[data-booking-search]").value = "";
        renderBookingFinder(); overlay.querySelector("[data-booking-scroll]").scrollTop = 0;
        var focus = all ? overlay.querySelector("[data-booking-category]") : area ? overlay.querySelector("[data-booking-areas-back]") : overlay.querySelector("[data-booking-all]");
        if (focus) focus.focus({preventScroll:true});
      }
      if (event.target.closest("[data-booking-more]")) { bookingFinder.limit += 8; renderBookingFinder(); }
      var consultation = event.target.closest("[data-booking-consultation]");
      if (consultation) {
        var key = consultation.getAttribute("data-booking-consultation");
        var panel = document.querySelector('[data-price-panel="' + key + '"]');
        if (!panel && window.DrSknnHomepageV2Performance && typeof window.DrSknnHomepageV2Performance.findPricingPanel === "function") panel = window.DrSknnHomepageV2Performance.findPricingPanel(key);
        var url = panel ? genericBookingUrl(panel) : "https://www.drsknn.uk/kiosk?tab=consultations";
        window.openDrSknnContainedBooking(url, consultation);
      }
    });
    return overlay;
  }

  function restoreBookingFinderIsolation() {
    bookingFinder.isolation.forEach(function (entry) {
      if (!entry.node.isConnected) return;
      entry.node.inert = entry.inert;
      if (entry.ariaHidden === null) entry.node.removeAttribute("aria-hidden");
      else entry.node.setAttribute("aria-hidden", entry.ariaHidden);
    });
    bookingFinder.isolation = [];
  }

  function isolateBookingFinderLayer(active) {
    restoreBookingFinderIsolation();
    Array.prototype.forEach.call(document.body.children, function (node) {
      if (node === active || node.tagName === "SCRIPT" || node.tagName === "STYLE") return;
      bookingFinder.isolation.push({ node: node, inert: Boolean(node.inert), ariaHidden: node.getAttribute("aria-hidden") });
      node.inert = true;
      node.setAttribute("aria-hidden", "true");
    });
    active.inert = false;
    active.removeAttribute("inert");
    active.setAttribute("aria-hidden", "false");
  }

  function lockBookingFinderScroll() {
    if (bookingFinder.lock) return;
    var body = document.body;
    bookingFinder.lock = { x: window.scrollX, y: window.scrollY, htmlOverflow: document.documentElement.style.overflow, bodyOverflow: body.style.overflow, position: body.style.position, top: body.style.top, width: body.style.width };
    document.documentElement.style.overflow = "hidden";
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = "-" + bookingFinder.lock.y + "px";
    body.style.width = "100%";
  }

  function unlockBookingFinderScroll() {
    var saved = bookingFinder.lock;
    if (!saved) return;
    bookingFinder.lock = null;
    document.documentElement.style.overflow = saved.htmlOverflow;
    document.body.style.overflow = saved.bodyOverflow;
    document.body.style.position = saved.position;
    document.body.style.top = saved.top;
    document.body.style.width = saved.width;
    window.scrollTo(saved.x, saved.y);
  }

  function bookingFinderBaseState(entryState) {
    var base = Object.assign({}, entryState || {});
    // A reload can retain our history marker even though this launch did not
    // push a new entry. The underlying page must never inherit that marker.
    delete base.pv3BookingFinder;
    return base;
  }

  function bookingFinderHistoryView(entryState) {
    if (new URLSearchParams(window.location.search || "").get("open") !== "treatment") return "";
    var view = entryState && entryState.pv3BookingFinder;
    return view === "finder" || view === "booking" ? view : "";
  }

  function openBookingFinder(trigger, fromHistory) {
    // A payment return owns the first screen. A successful no-op tells the
    // lazy entry bridge it is handled without covering or dismissing the update.
    if (bookingReturnState().status || document.querySelector("[data-pv3-booking-return]")) return true;
    if (!bookingFinderOptions().length) return false;
    if (bookingFinder.active) { if (!bookingFinder.suspended) resumeBookingFinder(); return true; }
    closeExactModalSilently();
    hideGuide({ restoreFocus: false });
    closeVisitBasket({ restoreFocus: false });
    var overlay = ensureBookingFinder();
    bookingFinder.opener = trigger && trigger.isConnected ? trigger : document.activeElement;
    bookingFinder.active = true;
    bookingFinder.suspended = false;
    var url = new URL(window.location.href);
    if (!fromHistory) {
      bookingFinder.baseState = bookingFinderBaseState(window.history.state);
      bookingFinder.baseUrl = url.toString();
      bookingFinder.pushed = url.searchParams.get("open") !== "treatment";
      if (!bookingFinder.pushed) { url.searchParams.delete("open"); bookingFinder.baseUrl = url.toString(); }
      url.searchParams.set("open", "treatment");
      url.hash = "";
      var nextState = Object.assign({}, window.history.state || {}, { pv3BookingFinder: "finder" });
      window.history[bookingFinder.pushed ? "pushState" : "replaceState"](nextState, "", url.toString());
    } else bookingFinder.pushed = true;
    overlay.hidden = false;
    lockBookingFinderScroll();
    syncVisitLauncher();
    isolateBookingFinderLayer(overlay);
    renderBookingFinder();
    overlay.querySelector("[data-booking-finder-close]").focus({ preventScroll: true });
    return true;
  }

  function finishBookingFinder() {
    if (!bookingFinder.active) return;
    closeVisitBasket({ restoreFocus: false });
    bookingFinder.active = false;
    bookingFinder.suspended = false;
    hideVisitNotice();
    if (bookingFinder.overlay) bookingFinder.overlay.hidden = true;
    restoreBookingFinderIsolation();
    unlockBookingFinderScroll();
    syncVisitLauncher();
    var opener = bookingFinder.opener;
    if (opener && opener.isConnected && !opener.closest("[inert]") && opener.getClientRects().length) opener.focus({ preventScroll: true });
  }

  function closeBookingFinder() {
   
    // Explicit dismissal must complete even when the iframe is the next joint
    // history entry. Browser Back is reconciled separately by popstate.
    window.history.replaceState(bookingFinder.baseState || {}, "", bookingFinder.baseUrl || window.location.pathname);
    finishBookingFinder();
  }

  function suspendBookingFinder(trigger) {
    if (bookingFinder.suspended) return;
    bookingFinder.selectionFocus = trigger && bookingFinder.overlay.contains(trigger) ? trigger : bookingFinder.overlay.querySelector("[data-booking-finder-close]");
    bookingFinder.suspended = true;
    hideVisitNotice();
    bookingFinder.overlay.hidden = true;
    restoreBookingFinderIsolation();
    bookingFinder.resumeUrl = window.location.href;
  }

  function resumeBookingFinder() {
    if (!bookingFinder.active || !bookingFinder.overlay) return;
    bookingFinder.suspended = false;
    bookingFinder.overlay.hidden = false;
    isolateBookingFinderLayer(bookingFinder.overlay);
    syncVisitLauncher();
    var target = bookingFinder.selectionFocus;
    if (!target || !target.isConnected) target = bookingFinder.overlay.querySelector("[data-booking-finder-close]");
    target.focus({ preventScroll: true });
  }

  function handleBookingFinderKeydown(event) {
    if (!bookingFinder.active || bookingFinder.suspended || bookingFinder.overlay.inert) return;
    if (event.key !== "Escape" && event.key !== "Tab") return;
    event.stopImmediatePropagation();
    if (event.key === "Escape") { event.preventDefault(); closeBookingFinder(); return; }
    var focusable = Array.prototype.filter.call(bookingFinder.overlay.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), summary'), function (node) { return !node.hidden && node.getClientRects().length; });
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !bookingFinder.overlay.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !bookingFinder.overlay.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  }

  function optionSignature(option) {
    return [normalize(option.title), option.role, option.audience || "", option.prices.map(function (entry) { return normalize(entry.label + " " + entry.value); }).join("|")].join("::");
  }

  function collectCatalogueOptions(panel, key) {
    var directByService = new Map();
    var fallbackBySignature = new Map();
    var directSignatures = new Set();

    panel.querySelectorAll("table").forEach(function (table) {
      var headers = tableHeaders(table);
      table.querySelectorAll("tbody tr").forEach(function (row) {
        var firstCell = row.querySelector(":scope > th, :scope > td");
        var rowHeading = cleanText(firstCell ? firstCell.textContent : "");
        if (!rowHeading) return;
        var links = Array.prototype.slice.call(row.querySelectorAll("[data-drsknn-pricing-service-id]"));

        if (links.length) {
          links.forEach(function (link) {
            var serviceId = link.getAttribute("data-drsknn-pricing-service-id");
            if (!serviceId || directByService.has(serviceId)) return;
            var role = link.getAttribute("data-drsknn-pricing-role") || "any_practitioner";
            var option = {
              direct: true,
              link: link,
              prices: rowPriceEntries(row, headers, role),
              role: role,
              audience: pricingAudience(row, key),
              serviceId: serviceId,
              sourceTitle: rowHeading,
              title: serviceLabelOverrides[serviceId] || rowHeading
            };
            directByService.set(serviceId, option);
            directSignatures.add(optionSignature(option));
          });
          return;
        }

        var fallbackRole = inferredRole(row, key);
        var fallbackPrices = rowPriceEntries(row, headers, fallbackRole);
        if (!fallbackPrices.length) return;
        var fallback = {
          direct: false,
          link: null,
          prices: fallbackPrices,
          role: fallbackRole,
          audience: pricingAudience(row, key),
          serviceId: "",
          title: rowHeading
        };
        var signature = optionSignature(fallback);
        if (!fallbackBySignature.has(signature)) fallbackBySignature.set(signature, fallback);
      });
    });

    var options = Array.from(directByService.values());
    fallbackBySignature.forEach(function (option, signature) {
      if (!directSignatures.has(signature)) options.push(option);
    });
    return options;
  }

  function genericBookingUrl(panel) {
    if (panel && panel.getAttribute("data-price-panel") === "antiwrinkle") return "https://www.drsknn.uk/book/v4/consultation/doctor";
    var link = Array.prototype.find.call(panel.querySelectorAll("[data-drsknn-booking-link]"), function (candidate) {
      return !candidate.hasAttribute("data-drsknn-pricing-service-id") && candidate.getAttribute("href");
    });
    return link ? link.getAttribute("href") : "https://www.drsknn.uk/kiosk?tab=consultations&landing_source=drsknn_com_pricing_v3&campaign=pricing_v3";
  }

  function copyServiceLink(source, title) {
    var link = document.createElement("a");
    var key = source.getAttribute("data-drsknn-pricing-key") || "";
    var providerRole = source.getAttribute("data-drsknn-pricing-role") || "";
    var policy = consultationPolicyForOption({ catalogueKey: key, role: providerRole });
    if (policy) {
      // Deliberately omit legacy direct-service attributes: the older pricing
      // observer would otherwise rewrite this consultation URL back to treatment.
      link.href = visitBookingUrl([{
        serviceId: source.getAttribute("data-drsknn-pricing-service-id") || "",
        catalogueKey: key,
        title: title,
        role: roleLabel(providerRole),
        providerRole: providerRole,
        consultationRole: policy.role,
        bookingUrl: source.getAttribute("href") || ""
      }]);
      link.setAttribute("data-pv3-consultation-link", policy.role);
    } else {
      Array.prototype.forEach.call(source.attributes, function (attribute) {
        if (attribute.name === "href" || attribute.name.indexOf("data-drsknn-") === 0) link.setAttribute(attribute.name, attribute.value);
      });
      link.setAttribute("data-pv3-option-link", "");
    }
    link.className = "drsknn-pv3-catalogue__select";
    link.textContent = policy ? "Book " + policy.role + " consultation" : "Choose this treatment";
    link.setAttribute("role", "button");
    if (!policy) link.setAttribute("aria-pressed", "false");
    link.setAttribute("aria-label", (policy ? "Book " + policy.role + " consultation for " : "Choose treatment: ") + title);
    return link;
  }

  var visitStorageKey = "drsknn_pricing_v3_visit";
  var visitSelections = [];
  var visitDurationByService = {};
  var visitDurationGroups = {
    15: "3589474,3589475,3589476,3589477,3589478,3589481,3589482,3589483",
    20: "3574670,3574671,3575580",
    25: "3574741,3574755",
    30: "3589479,3589480,3589484,3589485,3575649,3575765,3575657,3575773,3575484,3575486,3575443,3575446,3575444,3575488,3575450,3575440,3575483,3575487,3575449,3575442,3575448,3575445,3575441,3575447,3575482,3574701,3574706,3575290,3575287,3575588,3575589,3575766,3575767,3575650,3575651",
    40: "3575648,3575764,3575581",
    45: "3574430,3574409,3574429,3574408,3574414,3574389,3574413,3574386,3574422,3574401,3574412,3574385,3574402,3574423,3574410,3574383,3574411,3574384,3574397,3574428,3574421,3574400,3574419,3574398,3574420,3574399,3574416,3574391,3574415,3574390,3574424,3574403,3574425,3574404,3574426,3574405,3574427,3574406,3574396,3575655,3575771,3574542,3574634,3575094,3575072,3575050,3575087,3575065,3575043,3575086,3575064,3575042,3575459,3575492,3575451,3575458,3575491,3575493,3575460,3575457,3575452,3575455,3575453,3575456,3575454,3574703,3574708,3574704,3574709,3575286,3575284,3575291,3575028,3575006,3575021,3574999,3575020,3574998,3574960,3574936,3574953,3574929,3574952,3574928,3574961,3574937,3587140,3586944,3587000,3586940,3586968,3587168,3586964,3587072,3586936,3586976,3586988,3587076,3587156,3586972,3586932,3574890,3574866,3574883,3574859,3574882,3574858,3575769,3575653",
    60: "3574407,3575656,3575772,3574479,3574570,3574554,3575640,3575626,3575646,3575632,3575644,3575630,3575633,3575643,3575629,3575645,3575631,3575642,3575628,3575090,3575068,3575046,3575093,3575071,3575049,3575085,3575063,3575041,3575092,3575070,3575048,3575088,3575066,3575044,3575084,3575062,3575040,3575091,3575069,3575047,3575462,3575469,3575498,3575501,3575470,3575477,3575473,3575472,3575478,3575476,3575464,3575466,3575465,3575463,3575468,3575500,3575467,3575474,3575461,3575475,3575471,3574702,3574707,3574667,3574676,3574674,3574675,3574673,3574679,3574677,3574678,3574672,3574666,3574665,3574662,3574663,3574668,3574669,3574680,3574664,3575204,3575283,3575282,3575289,3575292,3575293,3574980,3575024,3575002,3574983,3575027,3575005,3575019,3574997,3574975,3574982,3575026,3575004,3575022,3575000,3574978,3575018,3574996,3574974,3574984,3574977,3574981,3575025,3575003,3574976,3574910,3574956,3574932,3574913,3574959,3574935,3574951,3574927,3574905,3574912,3574958,3574934,3574954,3574930,3574908,3574950,3574926,3574904,3574914,3574907,3574911,3574957,3574933,3574906,3575582,3587088,3586948,3586984,3586980,3587176,3587044,3586960,3587004,3587136,3586956,3587008,3587036,3586992,3587080,3587160,3587056,3587144,3587172,3586952,3574886,3574862,3574837,3574889,3574865,3574840,3574881,3574857,3574831,3574888,3574864,3574839,3574884,3574861,3574836,3574880,3574856,3574830,3574841,3574834,3574891,3574867,3574842,3574887,3574863,3574838,3574832,3574813,3574814,3574778,3574807,3574810,3574806,3574809,3574771,3574770,3574773,3574808,3574812,3574777,3574811,3574776,3574816,3574780,3575045,3575067,3575089,3574979,3575001,3575023,3574833,3574835,3574860,3574885,3574909,3574931,3574955,3574804,3575627,3575641",
    70: "3575583",
    75: "3575625,3587092,3587104,3587052,3587180,3587096,3587016,3587012,3587040,3587048,3587184,3587084,3587164,3587148,3587108,3587064",
    80: "3574498,3574586,3574510,3574602,3575584,3574772",
    90: "3574700,3574705,3575585,3587100,3587060,3587112,3587068,3587020,3587024,3587188,3587116,3587128,3587120,3587152,3587124",
    100: "3574526,3575586",
    105: "3587028,3587032,3587132",
    110: "3575587",
    120: "3574768,3574769,3574767,3576711,3576710,3576709"
  };

  Object.keys(visitDurationGroups).forEach(function (duration) {
    visitDurationGroups[duration].split(",").forEach(function (serviceId) {
      visitDurationByService[serviceId] = Number(duration);
    });
  });

  // Retire the old browser-wide plan. A visit now belongs only to this tab so
  // another tab (including clinic QA) cannot change what this visitor sees.
  try { window.localStorage.removeItem(visitStorageKey); } catch (_) {}
  try {
    visitSelections = JSON.parse(window.sessionStorage.getItem(visitStorageKey) || "[]");
    if (!Array.isArray(visitSelections)) visitSelections = [];
  } catch (_) {
    visitSelections = [];
  }
  if (bookingReturnState().status === "confirmed") {
    visitSelections = [];
    try { window.sessionStorage.removeItem(visitStorageKey); } catch (_) {}
  }
  visitSelections = visitSelections.filter(function (item) {
    return item && item.id && item.title;
  }).map(function (item) {
    if (item.serviceId && visitDurationByService[String(item.serviceId)]) {
      item.duration = visitDurationByService[String(item.serviceId)];
    }
    return item;
  }).slice(0, 10);
  var visitReturnFocus = null;
  var visitInertState = [];
  var visitNoticeTimer = 0;
  var visitUndoSelectionId = "";
  var visitAddGesture = null;
  var visitSuppressedAddButton = null;
  var visitSuppressedAddUntil = 0;
  var visitAddMoveThreshold = 10;

  function optionDuration(option) {
    var serviceDuration = visitDurationByService[String(option.serviceId || "")];
    if (serviceDuration) return serviceDuration;
    var duration = 0;
    (option.prices || []).some(function (entry) {
      if (normalize(entry.label).indexOf("duration") === -1 && normalize(entry.label).indexOf("time") === -1) return false;
      var match = String(entry.value || "").match(/(\d+)/);
      duration = match ? parseInt(match[1], 10) : 0;
      return Boolean(duration);
    });
    return duration || 30;
  }

  // Existing clinic service descriptions, matched by the canonical service ID.
  // Source: DRSKNN-Spatius-Private/routes/hydrafacial_menu.py (2026-10-11).
  function specificTreatmentExplanation(option) {
    if (!option || option.catalogueKey !== "hydrafacial") return "";
    var descriptions = {
      "3574662": "A complete facial with cleansing, exfoliation, extraction and hydration, finished with LED. A starting point for skin that feels dull or congested.",
      "3574663": "Targets hydration and skin-barrier support with tailored actives. Designed for skin that needs replenishing and a calmer-looking finish.",
      "3574664": "Cleansing, exfoliation and extraction with serums and boosters chosen around your skin concerns. Your practitioner helps tailor the treatment.",
      "3574665": "A moisture-focused facial using hydrating and antioxidant serums to refresh dry-feeling skin and leave it looking dewier.",
      "3574666": "Focuses on hydration, the appearance of fine lines and support for the skin barrier. For skin that feels dry or looks less supple.",
      "3574667": "Combines cleansing and exfoliation with brightening serums. Helps refresh the appearance of dull skin, uneven tone and congestion.",
      "3574668": "A targeted booster and hydration programme for the appearance of texture, fine lines and tired-looking skin.",
      "3574670": "Gentle exfoliation and hydrating, brightening care for the delicate under-eye area. Focuses on the appearance of tired-looking eyes.",
      "3574671": "Gentle cleansing, exfoliation and hydration for dry-feeling lips. A conditioning treatment; it does not add filler volume.",
      "3574669": "Targeted hydration and care for the neck and décolleté, including the appearance of dry, crepey skin and fine lines. This option includes both areas; choose it instead of HydraNECK or HydraCHEST.",
      "3574672": "Cleanse, exfoliate and hydrate the neck, with care tailored to its texture and hydration needs. For the neck only.",
      "3574673": "Cleansing, exfoliation and hydration for the chest and décolleté, focusing on rough texture, dryness and uneven-looking tone.",
      "3574674": "Deep cleansing, exfoliation and extraction for the back, followed by hydration. Targets build-up, congestion and rough-feeling skin.",
      "3574675": "Cleansing, exfoliation and hydration for the skin on the buttocks. Focuses on roughness and congestion, rather than changing body shape.",
      "3574676": "Cleansing, exfoliation and hydration for the arms, designed to refresh dry-feeling skin and improve the appearance of texture.",
      "3574677": "Gentle exfoliation and hydration to refresh dry-feeling hands and soften the appearance of rough texture.",
      "3574678": "Cleansing, exfoliation and hydration for the legs. Focuses on dull-looking, rough or dry-feeling skin.",
      "3574679": "Deep cleansing, exfoliation and hydration to lift scalp build-up and leave the scalp feeling refreshed and nourished. Scalp care can complement your facial in the same visit."
};
    return descriptions[String(option.serviceId || "")] || "";
  }

  function treatmentExplanation(option) {
    var specific = specificTreatmentExplanation(option);
    if (specific) return specific;
    var family = {
      antiwrinkle: "Discuss this area with a prescribing clinician. Suitability, alternatives, risks and any treatment plan are confirmed in consultation. Selecting an area records an interest; it does not book or promise treatment.",
      dermalfillers: "A consultation-led assessment of proportion, structure and the selected area before any product or volume is agreed.",
      prp: "Uses a prepared component of your own blood; discuss the proposed method, expected benefits, limitations and risks in consultation.",
      origin: "A laser option used for visible skin-quality and rejuvenation concerns; settings and recovery are personalised after assessment.",
      co2: "Fractional resurfacing considered for texture, scars or rejuvenation, with intensity and recovery confirmed during consultation.",
      hydrafacial: "A cleansing, exfoliation and hydration treatment tailored to the selected face, scalp or body area.",
      onda: "A body-treatment option considered for fat reduction, cellulite, skin tightening or contouring after suitability checks.",
      polynucleotide: "Discuss the exact polynucleotide product, proposed area, expected benefits, limitations and risks before deciding on treatment.",
      exosomes: "Ask which exosome-labelled product is proposed, how it would be used, and what evidence supports that use. Discuss limitations, risks and alternatives before deciding.",
      biologicalfiller: "Ask what the biological-filler option contains and how it is prepared and used. Discuss the evidence, limitations, risks and alternatives for the proposed area.",
      chemicalpeel: "A clinician-selected peel for concerns such as acne, pigmentation, texture or glow, with strength chosen after assessment.",
      hifu: "Focused-ultrasound treatment considered for lifting and skin-tightening concerns in the selected area.",
      dermalux: "Confirm the Dermalux device model and whether it is suitable for your concern. A category name does not establish which device or treatment is offered at a particular clinic.",
      mh10: "FILLMED describes M-HA 10 as an injectable device. Confirm the exact product and delivery method for this booking option; injection, microneedling and topical application are different routes.",
      nctf135: "A skin-revitalisation option; nurse and qualified-practitioner appointments are microneedled only.",
      dsmicroneedling: "A controlled microneedling treatment tailored to the selected area, skin concern and recovery preference.",
      ipl: "IPL considered for pigmentation, redness, acne or rejuvenation; settings depend on skin type and suitability.",
      hairreduction: "Laser hair-reduction treatment for the selected area; the clinic confirms settings, course and suitability.",
      threadingwaxingtinting: "A grooming treatment for the selected area, with the exact service confirmed before the appointment.",
      spmu: "A semi-permanent makeup service whose shape, colour and suitability are agreed before treatment."
    };
    return family[option.catalogueKey] || "The clinician confirms the selected area, suitability, exact plan and final price before treatment.";
  }

  function visitSelectionFromOption(option) {
    var policy = consultationPolicyForOption(option);
    return {
      id: option.serviceId || normalize(option.catalogueKey + "-" + option.title + "-" + option.role).replace(/\s+/g, "-"),
      serviceId: option.serviceId || "",
      catalogueKey: option.catalogueKey || "",
      title: option.title,
      role: displayedRoleLabel(option),
      providerRole: option.role || "",
      consultationRole: policy ? policy.role : visitInterestRole(option.role),
      duration: optionDuration(option),
      bookingUrl: option.link ? option.link.getAttribute("href") || "" : "",
      prices: (option.prices || []).map(function (entry) { return entry.label + " " + entry.value; }).join(" · ")
    };
  }

  function estimatedVisitMinutes() {
    if (!visitSelections.length) return 0;
    return visitSelections.reduce(function (sum, item) {
      return sum + Number(item.duration || 30);
    }, 0);
  }

  function saveVisitSelections() {
    try { window.sessionStorage.setItem(visitStorageKey, JSON.stringify(visitSelections)); } catch (_) {}
  }

  function closestVisitAddButton(target) {
    return target && target.nodeType === 1 && typeof target.closest === "function"
      ? target.closest("[data-pv3-add-visit]")
      : null;
  }

  function beginVisitAddGesture(button, pointerId, clientX, clientY) {
    if (!button) return;
    visitAddGesture = {
      button: button,
      pointerId: pointerId,
      startX: clientX,
      startY: clientY,
      moved: false
    };
  }

  function moveVisitAddGesture(pointerId, clientX, clientY) {
    if (!visitAddGesture || visitAddGesture.pointerId !== pointerId) return;
    var deltaX = Math.abs(clientX - visitAddGesture.startX);
    var deltaY = Math.abs(clientY - visitAddGesture.startY);
    if (Math.max(deltaX, deltaY) < visitAddMoveThreshold) return;
    visitAddGesture.moved = true;
    visitSuppressedAddButton = visitAddGesture.button;
    visitSuppressedAddUntil = Date.now() + 800;
  }

  function finishVisitAddGesture(pointerId) {
    if (!visitAddGesture || visitAddGesture.pointerId !== pointerId) return;
    if (visitAddGesture.moved) {
      visitSuppressedAddButton = visitAddGesture.button;
      visitSuppressedAddUntil = Date.now() + 800;
    }
    visitAddGesture = null;
  }

  function shouldSuppressVisitAddClick(button) {
    var shouldSuppress = button === visitSuppressedAddButton && Date.now() <= visitSuppressedAddUntil;
    if (shouldSuppress) {
      visitSuppressedAddButton = null;
      visitSuppressedAddUntil = 0;
    }
    return shouldSuppress;
  }

  function visitInterestRole(value) {
    var role = String(value || "").toLowerCase();
    if (role.indexOf("doctor") !== -1) return "doctor";
    if (role.indexOf("nurse") !== -1) return "nurse";
    if (role.indexOf("practitioner") !== -1 || role.indexOf("qualified") !== -1) return "practitioner";
    return "";
  }

  function consultationPolicyForSelection(item) {
    var key = item.catalogueKey || "";
    // Migrate an earlier saved Origin selection without relying on its display
    // label (which used to be "Any suitable clinician").
    if (!key && item.bookingUrl) {
      try {
        var source = new URL(item.bookingUrl);
        if (/^https:\/\/(?:www\.)?drsknn\.uk$/.test(source.origin) && !source.username && !source.password) key = source.searchParams.get("pricing_key") || "";
      } catch (_) {}
    }
    // Prefer the saved provider over a consultationRole written by the old
    // doctor-only rule. Legacy entries still retain their displayed role.
    return consultationPolicyForOption({ catalogueKey: key, role: item.providerRole || item.role || item.consultationRole });
  }

  function requiredConsultationRole(item) {
    var policy = consultationPolicyForSelection(item);
    return policy ? policy.role : visitInterestRole(item.consultationRole || item.providerRole || item.role);
  }

  function visitConsultationPolicy(selections) {
    if (!selections.length || !selections.some(function (item) { return Boolean(consultationPolicyForSelection(item)); })) return null;
    var policies = selections.map(consultationPolicyForSelection);
    var roles = selections.map(requiredConsultationRole);
    // Preserve the server's Origin override and anti-wrinkle doctor precedence.
    if (policies.some(function (policy) { return policy && policy.role === "doctor"; }) || roles.indexOf("doctor") !== -1) return { role: "doctor", label: "Doctor consultation" };
    if (roles.every(function (role) { return role === "nurse"; })) return { role: "nurse", label: "Nurse consultation" };
    return null;
  }

  function visitBookingUrl(selections) {
    var selected = Array.isArray(selections) ? selections : visitSelections;
    if (!selected.length || selected.length > 10) return "";
    var url = new URL("https://www.drsknn.uk/book/visit");
    try {
      var owner = new URL(window.location.href);
      if (/^https:\/\/(?:www\.)?drsknn\.(?:com|store|online)$/i.test(owner.origin)) url.searchParams.set("return_url", owner.origin + "/");
    } catch (_) {}
    var ids = [];
    var locations = [];
    var trustedLinks = [];
    var interests = selected.map(function (item) {
      // These are interests, never a client-authorised treatment or fee.
      var interest = { title: String(item.title || "Treatment interest").trim().slice(0, 160) };
      var serviceId = String(item.serviceId || "");
      if (/^[1-9]\d*$/.test(serviceId)) {
        interest.service_id = serviceId;
        if (ids.indexOf(serviceId) === -1) ids.push(serviceId);
      }
      var role = requiredConsultationRole(item);
      if (role) interest.role = role;
      var location = "";
      try {
        var exact = new URL(item.bookingUrl || "");
        if (/^https:\/\/(?:www\.)?drsknn\.uk$/.test(exact.origin) && !exact.username && !exact.password) {
          trustedLinks.push(exact.searchParams);
          location = exact.searchParams.get("loc") || exact.searchParams.get("location_id") || "";
        }
      } catch (_) {}
      locations.push(/^[1-9]\d*$/.test(location) ? location : "");
      return interest;
    });
    url.searchParams.set("booking_mode", "consultation");
    if (ids.length) url.searchParams.set("service_ids", ids.join(","));
    url.searchParams.set("selected_interests", JSON.stringify(interests));
    if (locations[0] && locations.every(function (location) { return location === locations[0]; })) {
      url.searchParams.set("loc", locations[0]);
    }
    url.searchParams.set("landing_source", "drsknn_com_pricing_v3");
    url.searchParams.set("campaign", "pricing_v3");
    url.searchParams.set("landing_page", "dr_sknn_pricing_v3");
    url.searchParams.set("funnel_stage", "pricing_v3_consultation_plan");
    url.searchParams.set("booking_route", "website_consultation_plan");
    // Retain the same attribution keys as the pricing row URLs. Never copy
    // patient status, payable amounts or appointment eligibility from the URL.
    var current = new URLSearchParams(window.location.search || "");
    ["gclid", "gbraid", "wbraid", "ttclid", "msclkid", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "drsknn_visitor_id", "drsknn_session_id"].forEach(function (key) {
      var value = current.get(key);
      if (!value) {
        var values = trustedLinks.map(function (params) { return params.get(key); }).filter(Boolean);
        if (values.length && values.every(function (entry) { return entry === values[0]; })) value = values[0];
      }
      if (value) url.searchParams.set(key, value);
    });
    return url.toString();
  }

  function exactVisitItemBookingUrl(item) {
    if (!item || consultationPolicyForSelection(item)) return "";
    var serviceId = String(item.serviceId || "");
    if (!/^\d+$/.test(serviceId) || !item.bookingUrl) return "";
    try {
      var url = new URL(item.bookingUrl);
      if (!/^https:\/\/(?:www\.)?drsknn\.uk$/.test(url.origin) || url.username || url.password) return "";
      if (!/^\/kiosk\/?$/.test(url.pathname)) return "";
      if (url.searchParams.get("direct") !== "1" || url.searchParams.get("booking_mode") !== "direct_service") return "";
      if (!url.searchParams.get("sid") && !url.searchParams.get("service_id")) return "";
      var ids = ["sid", "service_id", "selected_service_ids"].map(function (key) { return url.searchParams.get(key); }).filter(Boolean);
      if (!ids.length || ids.some(function (id) { return id !== serviceId; })) return "";
      return url.toString();
    } catch (_) {
      return "";
    }
  }

  function singleVisitBookingUrl() {
    return visitSelections.length === 1 ? exactVisitItemBookingUrl(visitSelections[0]) : "";
  }

  function treatmentVisitBookingUrl() {
    if (visitSelections.length === 1) return singleVisitBookingUrl();
    if (visitSelections.length < 2 || visitSelections.length > 10) return "";
    var ids = [];
    var locations = [];
    var practitioners = null;
    var valid = visitSelections.every(function (item) {
      var exact = exactVisitItemBookingUrl(item);
      var id = String(item.serviceId || "");
      if (!exact || ids.indexOf(id) !== -1) return false;
      ids.push(id);
      var params = new URL(exact).searchParams;
      locations.push(params.get("loc") || params.get("location_id") || "");
      var constraints = [params.get("emp"), params.get("employee_id"), params.get("employee_ids")].filter(Boolean);
      for (var index = 0; index < constraints.length; index += 1) {
        var pool = constraints[index].split(",").map(function (value) { return value.trim(); });
        if (pool.some(function (value) { return !/^[1-9]\d*$/.test(value); })) return false;
        practitioners = practitioners === null ? pool : practitioners.filter(function (value) { return pool.indexOf(value) !== -1; });
        if (!practitioners.length) return false;
      }
      return true;
    });
    if (!valid) return "";
    // The server validates every ID, combination, clinic, practitioner and price.
    // This URL carries selections, never a client-calculated payable total.
    var url = new URL("https://www.drsknn.uk/kiosk/book-treatments");
    url.searchParams.set("service_ids", ids.join(","));
    if (practitioners && practitioners.length) {
      url.searchParams.set(practitioners.length === 1 ? "employee_id" : "employee_ids", practitioners.join(","));
    }
    if (locations[0] && locations.every(function (loc) { return loc === locations[0]; })) {
      url.searchParams.set("loc", locations[0]);
    }
    url.searchParams.set("landing_source", "drsknn_com_pricing_v3");
    url.searchParams.set("campaign", "pricing_v3");
    url.searchParams.set("landing_page", "dr_sknn_pricing_v3");
    url.searchParams.set("funnel_stage", "pricing_v3_treatment_basket");
    url.searchParams.set("booking_route", "website_treatment_basket");
    return url.toString();
  }

  function syncVisitLauncher() {
    var launcher = document.querySelector("[data-pv3-visit-open]");
    if (!launcher) return;
    var exactOpen = pricingModalBackdrop && pricingModalBackdrop.classList.contains("drsknn-pricing-modal-open");
    var finderOpen = bookingFinder.active && !bookingFinder.suspended;
    var host = finderOpen ? bookingFinder.overlay.querySelector('[role="dialog"]') : (exactOpen ? pricingModalBackdrop.querySelector('[role="dialog"]') : document.body);
    if (host && launcher.parentElement !== host) host.appendChild(launcher);
    // This owned control belongs to the active pricing dialog, never its inert siblings.
    if ((exactOpen || finderOpen) && host) {
      launcher.inert = false;
      launcher.removeAttribute("inert");
      launcher.removeAttribute("aria-hidden");
    }
  }

  function isolateVisitBasket(overlay) {
    visitInertState = [];
    Array.prototype.forEach.call(document.body.children, function (node) {
      if (node === overlay || node.tagName === "SCRIPT" || node.tagName === "STYLE") return;
      visitInertState.push({ node: node, inert: Boolean(node.inert), ariaHidden: node.getAttribute("aria-hidden") });
      node.inert = true;
      node.setAttribute("aria-hidden", "true");
    });
  }

  function restoreVisitIsolation() {
    visitInertState.forEach(function (entry) {
      if (!entry.node.isConnected) return;
      entry.node.inert = entry.inert;
      if (entry.ariaHidden === null) entry.node.removeAttribute("aria-hidden");
      else entry.node.setAttribute("aria-hidden", entry.ariaHidden);
    });
    visitInertState = [];
  }

  function ensureVisitBasket() {
    if (document.querySelector("[data-pv3-visit-basket]")) return;
    var wrap = document.createElement("div");
    wrap.innerHTML = '<button type="button" class="drsknn-pv3-visit__launcher" data-pv3-visit-open hidden><span>Review my visit</span><strong data-pv3-visit-count>0</strong></button>' +
      '<div class="drsknn-pv3-visit__notice" data-pv3-visit-notice hidden>' +
        '<span data-pv3-visit-notice-text role="status" aria-live="polite" aria-atomic="true"></span>' +
        '<button type="button" data-pv3-visit-undo>Undo</button>' +
      '</div>' +
      '<div class="drsknn-pv3-visit__overlay" data-pv3-visit-basket hidden>' +
        '<section class="drsknn-pv3-visit__dialog" role="dialog" aria-modal="true" aria-labelledby="drsknn-pv3-visit-title">' +
          '<header><div><span>YOUR VISIT PLAN</span><h2 id="drsknn-pv3-visit-title">Review your visit</h2></div><button type="button" data-pv3-visit-close aria-label="Close visit plan">×</button></header>' +
          '<p class="drsknn-pv3-visit__intro" data-pv3-visit-intro></p>' +
          '<div class="drsknn-pv3-visit__selected"><strong data-pv3-visit-count-copy>0 treatments selected</strong><span>Nothing is booked or charged yet.</span></div>' +
          '<div class="drsknn-pv3-visit__items" data-pv3-visit-items></div>' +
          '<div class="drsknn-pv3-visit__add-more" role="group" aria-label="Add more to this visit">' +
            '<button type="button" data-pv3-visit-add-concerns><b aria-hidden="true">+</b><span><strong>Add more concerns</strong><small>Tell us what else you would like help with</small></span></button>' +
            '<button type="button" data-pv3-visit-add-treatments><b aria-hidden="true">+</b><span><strong>Add more treatments</strong><small>Browse the complete treatment price list</small></span></button>' +
          '</div>' +
          '<div class="drsknn-pv3-visit__summary"><span>Next step</span><strong data-pv3-visit-duration>Choose consultation time</strong></div>' +
          '<footer><button type="button" class="drsknn-pv3-visit__continue" data-pv3-visit-continue><span>Book a consultation</span><small>Choose a consultation time next</small><b aria-hidden="true">→</b></button><button type="button" class="drsknn-pv3-visit__consultation drsknn-pv3-visit__clear" data-pv3-visit-consultation hidden>Book a consultation instead</button><button type="button" class="drsknn-pv3-visit__clear" data-pv3-visit-clear>Clear visit plan</button></footer>' +
        '</section>' +
      '</div>';
    while (wrap.firstElementChild) document.body.appendChild(wrap.firstElementChild);
  }

  function hideVisitNotice() {
    if (visitNoticeTimer) window.clearTimeout(visitNoticeTimer);
    visitNoticeTimer = 0;
    visitUndoSelectionId = "";
    var notice = document.querySelector("[data-pv3-visit-notice]");
    if (notice) notice.hidden = true;
  }

  function showVisitNotice(message, undoSelectionId) {
    ensureVisitBasket();
    if (visitNoticeTimer) window.clearTimeout(visitNoticeTimer);
    var notice = document.querySelector("[data-pv3-visit-notice]");
    var undo = notice.querySelector("[data-pv3-visit-undo]");
    if (bookingFinder.active && !bookingFinder.suspended) {
      bookingFinder.overlay.querySelector('[role="dialog"]').appendChild(notice);
    } else if (pricingModalBackdrop && pricingModalBackdrop.classList.contains("drsknn-pricing-modal-open")) {
      pricingModalBackdrop.appendChild(notice);
    } else if (notice.parentElement !== document.body) {
      document.body.appendChild(notice);
    }
    notice.inert = false;
    notice.removeAttribute("inert");
    notice.removeAttribute("aria-hidden");
    notice.querySelector("[data-pv3-visit-notice-text]").textContent = message;
    visitUndoSelectionId = undoSelectionId || "";
    undo.hidden = !visitUndoSelectionId;
    notice.hidden = false;
    visitNoticeTimer = window.setTimeout(hideVisitNotice, 7000);
  }

  function renderVisitBasket(open) {
    ensureVisitBasket();
    var launcher = document.querySelector("[data-pv3-visit-open]");
    var overlay = document.querySelector("[data-pv3-visit-basket]");
    var items = overlay.querySelector("[data-pv3-visit-items]");
    var duration = overlay.querySelector("[data-pv3-visit-duration]");
    var countCopy = overlay.querySelector("[data-pv3-visit-count-copy]");
    document.querySelectorAll("[data-pv3-add-visit]").forEach(function (button) {
      try {
        var selection = JSON.parse(button.getAttribute("data-pv3-add-visit") || "{}");
        var selected = visitSelections.some(function (item) { return item.id === selection.id; });
        button.textContent = selected ? "✓ Added · Remove" : "+ Add to my visit";
        button.setAttribute("aria-pressed", String(selected));
      } catch (_) {}
    });
    if (overlay.hidden) syncVisitLauncher();
    launcher.hidden = !visitSelections.length;
    var consultationPolicy = visitConsultationPolicy(visitSelections);
    var continueButton = overlay.querySelector("[data-pv3-visit-continue]");
    continueButton.querySelector("span").textContent = consultationPolicy ? "Book " + consultationPolicy.role + " consultation" : "Choose a consultation time";
    continueButton.querySelector("small").textContent = "Keep all your selected treatment interests";
    overlay.querySelector("[data-pv3-visit-consultation]").hidden = true;
    overlay.querySelector("[data-pv3-visit-intro]").textContent = "Your selected interests will be carried into the consultation. Consultation fees are shown before you confirm. Where £50 applies, it is a consultation fee with VAT £0. Treatment guide prices below are not a charge for this booking.";
    launcher.querySelector("[data-pv3-visit-count]").textContent = String(visitSelections.length);
    items.innerHTML = "";
    if (countCopy) countCopy.textContent = visitSelections.length + (visitSelections.length === 1 ? " treatment selected" : " treatments selected");
    visitSelections.forEach(function (item, index) {
      var row = document.createElement("article");
      row.className = "drsknn-pv3-visit__item";
      row.innerHTML = "<b class=\"drsknn-pv3-visit__index\" aria-hidden=\"true\"></b><div><strong></strong><span></span><small></small></div><button type=\"button\">Remove</button>";
      row.querySelector(".drsknn-pv3-visit__index").textContent = String(index + 1);
      row.querySelector("strong").textContent = item.title;
      var itemPolicy = consultationPolicyForSelection(item);
      row.querySelector("span").textContent = itemPolicy ? itemPolicy.label : item.role || "Clinician confirmed next";
      row.querySelector("small").textContent = item.prices ? "Treatment guide price: " + item.prices : "Treatment price confirmed in clinic";
      row.querySelector("button").setAttribute("aria-label", "Remove " + item.title + " from visit plan");
      row.querySelector("button").setAttribute("data-pv3-visit-remove", item.id);
      items.appendChild(row);
    });
    duration.textContent = consultationPolicy ? consultationPolicy.label : "Choose consultation time";
    if (open === true) {
      hideVisitNotice();
      if (overlay.hidden) {
        if (document.activeElement instanceof HTMLElement) visitReturnFocus = document.activeElement;
        isolateVisitBasket(overlay);
      }
      overlay.inert = false;
      overlay.removeAttribute("inert");
      overlay.setAttribute("aria-hidden", "false");
      overlay.hidden = false;
      document.documentElement.classList.add("drsknn-pv3-visit-open");
      overlay.querySelector("[data-pv3-visit-close]").focus();
    }
  }

  function closeVisitBasket(options) {
    var overlay = document.querySelector("[data-pv3-visit-basket]");
    if (overlay) {
      overlay.hidden = true;
      overlay.setAttribute("aria-hidden", "true");
      restoreVisitIsolation();
      syncVisitLauncher();
    }
    document.documentElement.classList.remove("drsknn-pv3-visit-open");
    if ((!options || options.restoreFocus !== false) && visitReturnFocus && visitReturnFocus.isConnected) visitReturnFocus.focus();
    visitReturnFocus = null;
  }

  function visitPricingAreaKey() {
    var item = visitSelections[0] || {};
    var key = item.catalogueKey || "";
    if (!key && item.bookingUrl) {
      try { key = new URL(item.bookingUrl, window.location.href).searchParams.get("pricing_key") || ""; } catch (_) {}
    }
    var treatment = treatmentByKey[key];
    if (treatment && treatment.areas && treatment.areas.length === 1) return treatment.areas[0];
    return concerns[state.area] ? state.area : "";
  }

  function returnToPricingFromVisit(route, trigger) {
    closeVisitBasket({ restoreFocus: false });
    if (bookingFinder.active && route === "treatments") {
      resumeBookingFinder();
      bookingFinder.overlay.querySelector("[data-booking-search]").focus({ preventScroll: true });
      return;
    }
    if (bookingFinder.active) {
      window.history.replaceState(bookingFinder.baseState || {}, "", bookingFinder.baseUrl);
      finishBookingFinder();
    }
    var exactClose = document.querySelector("[data-pricing-close-modal]");
    var treatmentPricingTrigger = document.querySelector('[data-drsknn-treatment-v3] [data-tv3-open="pricing"]');
    if (exactClose && pricingModalBackdrop && pricingModalBackdrop.classList.contains("drsknn-pricing-modal-open")) closeExactModalWithinPricing(exactClose);

    window.setTimeout(function () {
      if (treatmentPricingTrigger && typeof treatmentPricingTrigger.click === "function") treatmentPricingTrigger.click();
      window.setTimeout(function () {
        // An exact Treatment V3 page re-applies its default pricing key when it
        // opens the contained pricing journey. Close that re-opened exact card
        // before returning the visitor to the broader concerns/treatments view.
        var reopenedExactClose = document.querySelector("[data-pricing-close-modal]");
        if (reopenedExactClose && pricingModalBackdrop && pricingModalBackdrop.classList.contains("drsknn-pricing-modal-open")) {
          closeExactModalWithinPricing(reopenedExactClose);
        }
        setQuery({ pricing: "" }, {
          state: { pv3GuideView: "base", pv3GuideDepth: 0, pv3ExactSource: "" }
        });
        exactSource = "";
        if (route === "concerns") {
          setMode("help", { history: false, focus: false });
          var areaKey = visitPricingAreaKey();
          if (areaKey) {
            chooseArea(areaKey, trigger, { history: false, focus: true });
          } else {
            root.scrollIntoView({ behavior: "smooth", block: "start" });
            var firstArea = areaGrid && areaGrid.querySelector("[data-pv3-area]");
            if (firstArea) firstArea.focus();
          }
          return;
        }
        setMode("search", { history: false, focus: true });
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      }, treatmentPricingTrigger ? 140 : 0);
    }, exactClose ? 80 : 0);
  }

  function visitFocusables() {
    var overlay = document.querySelector("[data-pv3-visit-basket]");
    if (!overlay) return [];
    return Array.prototype.slice.call(
      overlay.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function handleVisitKeydown(event) {
    var overlay = document.querySelector("[data-pv3-visit-basket]");
    if (!overlay || overlay.hidden) return;
    if (event.key === "Escape" || event.key === "Tab") event.stopImmediatePropagation();
    if (event.key === "Escape") {
      event.preventDefault();
      closeVisitBasket();
      return;
    }
    if (event.key !== "Tab") return;
    var focusables = visitFocusables();
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function optionCard(option, fallbackUrl) {
    var article = document.createElement("article");
    var heading = document.createElement("h3");
    var provider = document.createElement("span");
    var prices = document.createElement("div");
    var action;
    var actions = document.createElement("div");
    var details = document.createElement("details");
    var summary = document.createElement("summary");
    var explanation = document.createElement("p");
    article.className = "drsknn-pv3-catalogue__option";
    article.setAttribute("data-pv3-option", "");
    article.setAttribute("data-pv3-option-title", option.title);
    article.setAttribute("data-pv3-option-provider", option.role);
    article.setAttribute("data-pv3-option-duration", String(optionDuration(option)));
    article.setAttribute("data-pv3-option-price", option.prices.map(function (entry) { return entry.label + " " + entry.value; }).join(" · "));
    article.setAttribute("data-pv3-option-service-type", groomingServiceType(option, option.catalogueKey));
    article.setAttribute("data-pv3-option-search", normalize(option.title + " " + displayedRoleLabel(option) + " " + (option.audience || "") + " " + option.prices.map(function (entry) { return entry.label + " " + entry.value; }).join(" ")));

    provider.className = "drsknn-pv3-catalogue__provider";
    provider.textContent = displayedRoleLabel(option);
    heading.textContent = option.title;
    prices.className = "drsknn-pv3-catalogue__prices";
    option.prices.forEach(function (entry) {
      var price = document.createElement("div");
      var label = document.createElement("span");
      var value = document.createElement("strong");
      label.textContent = entry.label;
      value.textContent = entry.value;
      price.appendChild(label);
      price.appendChild(value);
      prices.appendChild(price);
    });

    if (option.direct) {
      action = copyServiceLink(option.link, option.title);
    } else {
      action = document.createElement("a");
      action.className = "drsknn-pv3-catalogue__select drsknn-pv3-catalogue__select--secondary";
      action.href = fallbackUrl;
      action.textContent = "Ask about this treatment";
      action.setAttribute("data-drsknn-booking-link", "");
      action.setAttribute("data-drsknn-booking-key", "pricing-v3-unmapped-price");
      if (option.catalogueKey === "antiwrinkle") {
        action.removeAttribute("data-drsknn-booking-link"); action.removeAttribute("data-drsknn-booking-key");
        action.setAttribute("data-pv3-consultation-link", "doctor"); action.textContent = "Discuss this area in consultation";
      }
    }

    actions.className = "drsknn-pv3-catalogue__actions";
    actions.appendChild(action);
    if (option.direct) {
      var add = document.createElement("button");
      add.type = "button";
      add.className = "drsknn-pv3-catalogue__add";
      add.textContent = "Add to my visit";
      add.setAttribute("data-pv3-add-visit", JSON.stringify(visitSelectionFromOption(option)));
      actions.appendChild(add);
    }
    details.className = "drsknn-pv3-catalogue__about";
    summary.textContent = "About this option";
    explanation.textContent = treatmentExplanation(option);
    details.appendChild(summary);
    details.appendChild(explanation);

    article.appendChild(provider);
    article.appendChild(heading);
    article.appendChild(prices);
    article.appendChild(details);
    article.appendChild(actions);
    return article;
  }

  function rolePriority(role) {
    var priorities = {
      doctor: 0,
      nurse: 1,
      qualified_practitioner: 2,
      nurse_qualified_practitioner: 3,
      any_practitioner: 4
    };
    return Object.prototype.hasOwnProperty.call(priorities, role) ? priorities[role] : 5;
  }

  function containsAny(value, terms) {
    return terms.some(function (term) { return value.indexOf(term) !== -1; });
  }

  function groomingServiceType(option, key) {
    if (key !== "threadingwaxingtinting") return "all";
    var title = normalize(option && option.title);
    if (title.indexOf("tint") !== -1) return "tinting";
    if (title.indexOf("thread") !== -1) return "threading";
    if (title.indexOf("wax") !== -1) return "waxing";
    return "other";
  }

  function catalogueGroupOrder(key) {
    var orders = {
      antiwrinkle: ["Packages", "Face & eyes", "Neck & décolletage", "Upper body", "Other"],
      dermalfillers: ["Lips & mouth", "Cheeks & lower face", "Eyes", "Other"],
      prp: ["Face & eyes", "Face & neck", "Neck & décolletage", "Scalp & hair", "Body", "Other"],
      hairreduction: [
        "Women · Face", "Women · Neck", "Women · Upper body", "Women · Torso", "Women · Intimate", "Women · Lower body", "Women · Packages", "Women · Other",
        "Men · Face", "Men · Neck", "Men · Upper body", "Men · Torso", "Men · Intimate", "Men · Lower body", "Men · Packages", "Men · Other",
        "Other"
      ],
      hydrafacial: ["Face", "Scalp & hair", "Eyes", "Lips", "Neck & décolletage", "Buttocks", "Upper body", "Lower body", "Other"],
      origin: ["Face", "Eyes", "Neck & décolletage", "Combinations", "Scars & stretch marks", "Upper body", "Lower body", "Scalp & specialist", "Other"],
      polynucleotide: ["Face", "Eyes", "Neck & décolletage", "Combinations", "Scalp & hair", "Body", "Other"],
      co2: ["Face & eyes", "Face & neck", "Neck & décolletage", "Body & scars", "Other"],
      dsmicroneedling: ["Face & eyes", "Face & neck", "Neck & décolletage", "Upper body", "Lower body", "Scalp & hair", "Other"],
      hifu: ["Face & neck combinations", "Face & eyes", "Neck & décolletage", "Upper body", "Torso", "Lower body", "Other"]
    };
    return orders[key] || ["Face & eyes", "Face & neck", "Neck & décolletage", "Upper body", "Torso", "Intimate", "Lower body", "Scalp & hair", "Packages", "Other"];
  }

  function areaGroupForOption(option, key) {
    var value = normalize(option.sourceTitle || option.title);
    var combined = /[+]/.test(option.sourceTitle || option.title);
    var face = ["face", "facial", "eye", "brow", "lid", "tear", "crow", "forehead", "glabella", "nose", "nostril", "perioral", "temple", "lip", "cheek", "jaw", "chin", "sideburn", "beard", "ear"];
    var upper = ["hand", "finger", "arm", "underarm", "axilla", "shoulder"];
    var torso = ["chest", "stomach", "abdomen", "back", "buttock", "nipple", "navel", "flank", "torso"];
    var lower = ["leg", "thigh", "knee", "ankle", "foot", "feet", "toe"];
    var intimate = ["bikini", "hollywood", "brazilian", "perianal", "intimate"];
    var scalp = ["scalp", "hairline", "crown", "recession", "hair growth"];
    var packages = ["package", "full body", "combination", "multiple areas"];
    var scars = ["scar", "stretch mark"];
    var faceAndNeck = containsAny(value, face) && value.indexOf("neck") !== -1;

    if (key === "antiwrinkle") {
      if (/^(?:2|3|two|three) (?:classic )?areas?$/.test(value)) return "Packages";
      if (containsAny(value, ["traptox", "trap tox", "trapezius"])) return "Upper body";
      if (containsAny(value, ["platysmal", "neck", "decollet"])) return "Neck & décolletage";
      if (containsAny(value, ["frown", "gummy smile", "bunny", "jaw reduction", "masseter", "downturned", "downward turned mouth", "jowl", "mouth corner"].concat(face))) return "Face & eyes";
      return "Other";
    }

    if (key === "dermalfillers") {
      if (containsAny(value, ["tear", "eye"])) return "Eyes";
      if (containsAny(value, ["lip", "mouth", "perioral", "smoker", "nasolabial", "marionette", "gummy"])) return "Lips & mouth";
      if (containsAny(value, ["cheek", "chin", "jaw", "jowl"])) return "Cheeks & lower face";
      return "Other";
    }

    if (key === "prp") {
      if (containsAny(value, scalp)) return "Scalp & hair";
      if (faceAndNeck) return "Face & neck";
      if (containsAny(value, ["decollet", "neck"])) return "Neck & décolletage";
      if (containsAny(value, ["body", "hand", "arm", "chest", "abdomen", "scar", "stretch mark"].concat(lower, torso))) return "Body";
      if (containsAny(value, face)) return "Face & eyes";
      return "Other";
    }

    if (key === "hairreduction") {
      var audience = option.audience ? option.audience + " · " : "";
      if (containsAny(value, packages)) return audience + "Packages";
      if (containsAny(value, intimate)) return audience + "Intimate";
      if (containsAny(value, lower)) return audience + "Lower body";
      if (containsAny(value, upper)) return audience + "Upper body";
      if (containsAny(value, torso)) return audience + "Torso";
      if (value.indexOf("neck") !== -1) return audience + "Neck";
      if (containsAny(value, face)) return audience + "Face";
      return audience ? audience + "Other" : "Other";
    }

    if (key === "hydrafacial") {
      if (value.indexOf("scalp") !== -1 || value.indexOf("hair") !== -1) return "Scalp & hair";
      if (containsAny(value, ["periorbital", "eye", "eyes"])) return "Eyes";
      if (containsAny(value, ["perioral", "lip", "lips"])) return "Lips";
      if (value.indexOf("hydrabooty") !== -1 || value.indexOf("hydra booty") !== -1 || value.indexOf("buttock") !== -1) return "Buttocks";
      if (value.indexOf("neck") !== -1 || value.indexOf("decollet") !== -1 || value.indexOf("hydrachest") !== -1) return "Neck & décolletage";
      if (containsAny(value, lower)) return "Lower body";
      if (containsAny(value, upper.concat(["hydraback", "hydra back", "back", "chest"]))) return "Upper body";
      if (
        containsAny(value, face) ||
        containsAny(value, ["platinum", "tailor made", "rebuild recharge repair", "hydrate plump protect", "intense hydration", "brighten balance", "regenerate"])
      ) return "Face";
      return "Other";
    }

    if (key === "origin") {
      if (containsAny(value, scars)) return "Scars & stretch marks";
      if (containsAny(value, scalp)) return "Scalp & specialist";
      if (faceAndNeck || (combined && containsAny(value, face.concat(["neck", "decollet"])))) return "Combinations";
      if (containsAny(value, ["periorbital", "eye", "eyes", "eyelid", "lid", "brow", "crow", "tear trough"])) return "Eyes";
      if (value.indexOf("neck") !== -1 || value.indexOf("decollet") !== -1) return "Neck & décolletage";
      if (containsAny(value, lower.concat(["buttock"]))) return "Lower body";
      if (containsAny(value, upper.concat(torso))) return "Upper body";
      if (containsAny(value, face)) return "Face";
      return "Other";
    }

    if (key === "polynucleotide") {
      if (containsAny(value, scalp)) return "Scalp & hair";
      if (faceAndNeck || (combined && containsAny(value, face.concat(["neck", "decollet"])))) return "Combinations";
      if (containsAny(value, ["periorbital", "eye", "eyes", "tear trough"])) return "Eyes";
      if (containsAny(value, ["decollet", "neck"])) return "Neck & décolletage";
      if (containsAny(value, ["body", "hand", "arm", "chest", "abdomen", "scar", "stretch mark"].concat(lower, torso))) return "Body";
      if (containsAny(value, face)) return "Face";
      return "Other";
    }

    if (key === "co2") {
      if (faceAndNeck) return "Face & neck";
      if (value.indexOf("neck") !== -1 || value.indexOf("decollet") !== -1) return "Neck & décolletage";
      if (containsAny(value, scars.concat(upper, torso, lower))) return "Body & scars";
      if (containsAny(value, face)) return "Face & eyes";
      return "Other";
    }

    if (key === "dsmicroneedling") {
      if (containsAny(value, scalp)) return "Scalp & hair";
      if (faceAndNeck) return "Face & neck";
      if (value.indexOf("neck") !== -1 || value.indexOf("decollet") !== -1) return "Neck & décolletage";
      if (containsAny(value, lower.concat(["buttock"]))) return "Lower body";
      if (containsAny(value, upper.concat(torso))) return "Upper body";
      if (containsAny(value, face)) return "Face & eyes";
      return "Other";
    }

    if (key === "hifu") {
      if ((value.indexOf("face") !== -1 && value.indexOf("neck") !== -1) || (value.indexOf("jaw") !== -1 && value.indexOf("neck") !== -1)) return "Face & neck combinations";
      if (value.indexOf("neck") !== -1 || value.indexOf("decollet") !== -1) return "Neck & décolletage";
      if (containsAny(value, lower)) return "Lower body";
      if (containsAny(value, upper)) return "Upper body";
      if (containsAny(value, torso)) return "Torso";
      if (containsAny(value, face)) return "Face & eyes";
      return "Other";
    }

    if (containsAny(value, packages)) return "Packages";
    if (containsAny(value, intimate)) return "Intimate";
    if (containsAny(value, scalp)) return "Scalp & hair";
    if (faceAndNeck) return "Face & neck";
    if (value.indexOf("neck") !== -1 || value.indexOf("decollet") !== -1) return "Neck & décolletage";
    if (containsAny(value, lower)) return "Lower body";
    if (containsAny(value, upper)) return "Upper body";
    if (containsAny(value, torso)) return "Torso";
    if (containsAny(value, face)) return "Face & eyes";
    return "Other";
  }

  function groupedCatalogueOptions(options, key) {
    var order = catalogueGroupOrder(key);
    var groups = new Map();
    options.forEach(function (option, index) {
      var label = areaGroupForOption(option, key);
      option.catalogueIndex = index;
      option.catalogueKey = key;
      option.catalogueGroup = label;
      if (!groups.has(label)) groups.set(label, []);
      groups.get(label).push(option);
    });
    return Array.from(groups.entries()).map(function (entry) {
      entry[1].sort(function (a, b) {
        return (key === "antiwrinkle" ? antiwrinklePackageRank(a) - antiwrinklePackageRank(b) : 0) || rolePriority(a.role) - rolePriority(b.role) || a.catalogueIndex - b.catalogueIndex;
      });
      return { label: entry[0], options: entry[1] };
    }).sort(function (a, b) {
      var aIndex = order.indexOf(a.label);
      var bIndex = order.indexOf(b.label);
      return (aIndex === -1 ? order.length : aIndex) - (bIndex === -1 ? order.length : bIndex);
    });
  }

  function antiwrinkleOptionCard(group, fallbackUrl) {
    var selected = group.options[0];
    var card = document.createElement("article");
    function render() {
      var content = optionCard(selected, fallbackUrl);
      Array.prototype.slice.call(card.attributes).forEach(function (attribute) { card.removeAttribute(attribute.name); });
      Array.prototype.slice.call(content.attributes).forEach(function (attribute) { card.setAttribute(attribute.name, attribute.value); });
      card.setAttribute("data-pv3-option-providers", group.options.map(function (option) { return option.role; }).join(" "));
      card.setAttribute("data-pv3-option-search", group.options.map(function (option) { return normalize(option.title + " " + displayedRoleLabel(option) + " " + option.prices.map(function (price) { return price.value; }).join(" ")); }).join(" "));
      card.textContent = "";
      while (content.firstChild) card.appendChild(content.firstChild);
      if (group.options.length > 1) {
        var choices = document.createElement("div"); choices.className = "drsknn-pv3-catalogue__provider-choices";
        choices.setAttribute("role", "group"); choices.setAttribute("aria-label", "Choose clinician price for " + selected.title);
        group.options.forEach(function (option) {
          var button = document.createElement("button"); button.type = "button";
          button.setAttribute("data-pv3-provider-choice-role", option.role);
          button.setAttribute("data-pv3-provider-choice-service", option.serviceId);
          button.setAttribute("aria-pressed", String(option.serviceId === selected.serviceId));
          var label = document.createElement("strong"); label.textContent = roleLabel(option.role);
          var price = document.createElement("span"); var single = bookingSinglePrice(option); price.textContent = single ? single.value : "Price on request";
          button.appendChild(label); button.appendChild(price);
          button.addEventListener("click", function (event) {
            var restoreFocus = document.activeElement === button;
            selected = option; render();
            // A manual card choice must not contradict the global clinician filter.
            // Filter-driven choice.click() events are untrusted and retain that filter.
            if (event.isTrusted) {
              var catalogue = card.closest("[data-pv3-catalogue]");
              var activeFilter = catalogue && catalogue.querySelector('[data-pv3-provider-filter][aria-pressed="true"]');
              if (activeFilter && activeFilter.getAttribute("data-pv3-provider-filter") !== "all" && activeFilter.getAttribute("data-pv3-provider-filter") !== option.role) {
                var allClinicians = catalogue.querySelector('[data-pv3-provider-filter="all"]');
                if (allClinicians) allClinicians.click();
              }
            }
            var current = card.querySelector('[data-pv3-provider-choice-service="' + option.serviceId + '"]');
            if (current && restoreFocus) current.focus({preventScroll:true});
          });
          choices.appendChild(button);
        });
        card.insertBefore(choices, card.querySelector(".drsknn-pv3-catalogue__about"));
      }
    }
    render();
    return card;
  }

  function catalogueGroup(group, fallbackUrl, open) {
    var section = document.createElement("section");
    var toggle = document.createElement("button");
    var label = document.createElement("span");
    var count = document.createElement("span");
    var chevron = document.createElement("span");
    var panel = document.createElement("div");
    var grid = document.createElement("div");
    var panelId = "drsknn-pv3-area-" + normalize(group.label).replace(/\s+/g, "-") + "-" + Math.random().toString(36).slice(2, 8);

    section.className = "drsknn-pv3-catalogue__group";
    section.setAttribute("data-pv3-catalogue-group", "");
    section.setAttribute("data-pv3-group-label", group.label);
    toggle.type = "button";
    toggle.className = "drsknn-pv3-catalogue__group-toggle";
    toggle.setAttribute("data-pv3-group-toggle", "");
    toggle.setAttribute("aria-expanded", String(open));
    toggle.setAttribute("aria-controls", panelId);
    label.textContent = group.label;
    count.textContent = group.options.length + (group.options.length === 1 ? " option" : " options");
    count.setAttribute("data-pv3-group-count", "");
    chevron.className = "drsknn-pv3-catalogue__group-chevron";
    chevron.setAttribute("aria-hidden", "true");
    chevron.textContent = "⌄";
    toggle.appendChild(label);
    toggle.appendChild(count);
    toggle.appendChild(chevron);
    panel.id = panelId;
    panel.className = "drsknn-pv3-catalogue__group-panel";
    panel.setAttribute("data-pv3-group-panel", "");
    panel.hidden = !open;
    grid.className = "drsknn-pv3-catalogue__grid";
    if (group.options[0] && group.options[0].catalogueKey === "antiwrinkle") {
      bookingTreatmentGroups(group.options, "").forEach(function (family) { grid.appendChild(antiwrinkleOptionCard(family, fallbackUrl)); });
    } else group.options.forEach(function (option) { grid.appendChild(optionCard(option, fallbackUrl)); });
    panel.appendChild(grid);
    section.appendChild(toggle);
    section.appendChild(panel);
    return section;
  }

  function catalogueFilters(roles) {
    var labels = [{ value: "all", label: "All clinicians" }].concat(roles.slice().sort(function (a, b) { return rolePriority(a) - rolePriority(b); }).map(function (role) {
      return { value: role, label: roleLabel(role) };
    }));
    var wrap = document.createElement("div");
    wrap.className = "drsknn-pv3-catalogue__filters";
    wrap.setAttribute("role", "group");
    wrap.setAttribute("aria-label", "Filter prices by clinician");
    labels.forEach(function (item) {
      var button = document.createElement("button");
      button.type = "button";
      button.textContent = item.label;
      button.setAttribute("data-pv3-provider-filter", item.value);
      button.setAttribute("aria-pressed", String(item.value === "all"));
      wrap.appendChild(button);
    });
    return wrap;
  }

  function groomingServiceTypeFilters(options) {
    var types = [
      { value: "waxing", label: "Waxing" },
      { value: "threading", label: "Threading" },
      { value: "tinting", label: "Tinting" }
    ];
    var wrap = document.createElement("div");
    var prompt = document.createElement("span");
    wrap.className = "drsknn-pv3-catalogue__service-types";
    wrap.setAttribute("role", "group");
    wrap.setAttribute("aria-label", "Choose waxing, threading or tinting");
    prompt.textContent = "Choose a service type";
    wrap.appendChild(prompt);
    types.forEach(function (item) {
      var count = options.filter(function (option) {
        return groomingServiceType(option, "threadingwaxingtinting") === item.value;
      }).length;
      var button = document.createElement("button");
      var label = document.createElement("strong");
      var total = document.createElement("small");
      button.type = "button";
      button.setAttribute("data-pv3-service-type-filter", item.value);
      button.setAttribute("aria-pressed", String(item.value === "waxing"));
      label.textContent = item.label;
      total.textContent = count + (count === 1 ? " treatment" : " treatments");
      button.appendChild(label);
      button.appendChild(total);
      wrap.appendChild(button);
    });
    return wrap;
  }

  function enableCatalogueControls(catalogue) {
    var input = catalogue.querySelector("[data-pv3-catalogue-search]");
    var filterButtons = Array.prototype.slice.call(catalogue.querySelectorAll("[data-pv3-provider-filter]"));
    var typeButtons = Array.prototype.slice.call(catalogue.querySelectorAll("[data-pv3-service-type-filter]"));
    var cards = Array.prototype.slice.call(catalogue.querySelectorAll("[data-pv3-option]"));
    var meta = catalogue.querySelector("[data-pv3-catalogue-meta]");
    var showAll = catalogue.querySelector("[data-pv3-show-all]");
    var groups = Array.prototype.slice.call(catalogue.querySelectorAll("[data-pv3-catalogue-group]"));
    var activeRole = "all";
    var activeType = catalogue.getAttribute("data-pv3-catalogue") === "threadingwaxingtinting" ? "waxing" : "all";
    var completeView = false;

    function setGroupOpen(group, open) {
      var toggle = group.querySelector("[data-pv3-group-toggle]");
      var panel = group.querySelector("[data-pv3-group-panel]");
      if (toggle) toggle.setAttribute("aria-expanded", String(open));
      if (panel) panel.hidden = !open;
    }

    function update() {
      var query = normalize(input.value);
      var matches = cards.filter(function (card) {
        var providers = card.getAttribute("data-pv3-option-providers");
        var roleMatch = activeRole === "all" || (providers ? providers.split(" ").indexOf(activeRole) !== -1 : card.getAttribute("data-pv3-option-provider") === activeRole);
        if (roleMatch && providers && activeRole !== "all") {
          var choice = card.querySelector('[data-pv3-provider-choice-role="' + activeRole + '"]');
          if (choice && choice.getAttribute("aria-pressed") !== "true") choice.click();
        }
        var typeMatch = activeType === "all" || card.getAttribute("data-pv3-option-service-type") === activeType;
        var searchMatch = !query || String(card.getAttribute("data-pv3-option-search") || "").indexOf(query) !== -1;
        return roleMatch && typeMatch && searchMatch;
      });
      cards.forEach(function (card) { card.hidden = true; });
      matches.forEach(function (card) { card.hidden = false; });

      var visibleGroups = groups.filter(function (group) {
        var visibleCards = Array.prototype.slice.call(group.querySelectorAll("[data-pv3-option]")).filter(function (card) { return !card.hidden; });
        var count = group.querySelector("[data-pv3-group-count]");
        group.hidden = visibleCards.length === 0;
        if (count) count.textContent = visibleCards.length + (visibleCards.length === 1 ? " option" : " options");
        return visibleCards.length > 0;
      });

      if (query || completeView) {
        visibleGroups.forEach(function (group) { setGroupOpen(group, true); });
      } else {
        var current = visibleGroups.find(function (group) {
          var toggle = group.querySelector("[data-pv3-group-toggle]");
          return toggle && toggle.getAttribute("aria-expanded") === "true";
        }) || visibleGroups[0];
        visibleGroups.forEach(function (group) { setGroupOpen(group, group === current); });
      }

      var typeLabel = activeType === "all" ? "" : " " + activeType;
      meta.textContent = matches.length
        ? matches.length + typeLabel + (matches.length === 1 ? " treatment" : " treatments") + " across " + visibleGroups.length + (visibleGroups.length === 1 ? " area" : " areas") + (activeRole === "all" && !typeButtons.length ? " · Doctor options appear first" : "")
        : "No matching " + (activeType === "all" ? "" : activeType + " ") + "treatments";
      if (typeButtons.length) input.placeholder = "Search " + activeType + " treatments…";
      showAll.hidden = Boolean(query) || visibleGroups.length <= 1;
      showAll.textContent = completeView ? "Return to one area at a time" : "View complete list (" + matches.length + ")";
    }

    input.addEventListener("input", update);
    typeButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        activeType = button.getAttribute("data-pv3-service-type-filter") || "waxing";
        completeView = false;
        input.value = "";
        typeButtons.forEach(function (candidate) {
          candidate.setAttribute("aria-pressed", String(candidate === button));
        });
        update();
      });
    });
    filterButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        activeRole = button.getAttribute("data-pv3-provider-filter") || "all";
        filterButtons.forEach(function (candidate) { candidate.setAttribute("aria-pressed", String(candidate === button)); });
        update();
      });
    });
    groups.forEach(function (group) {
      var toggle = group.querySelector("[data-pv3-group-toggle]");
      if (!toggle) return;
      toggle.addEventListener("click", function () {
        var willOpen = toggle.getAttribute("aria-expanded") !== "true";
        if (!completeView && !normalize(input.value)) {
          groups.forEach(function (candidate) { setGroupOpen(candidate, candidate === group && willOpen); });
        } else {
          setGroupOpen(group, willOpen);
        }
      });
    });
    showAll.addEventListener("click", function () { completeView = !completeView; update(); });
    update();
  }

  function ensureStandardCatalogue(key) {
    var panel = document.querySelector('[data-price-panel="' + key + '"]');
    if (!panel && window.DrSknnHomepageV2Performance && typeof window.DrSknnHomepageV2Performance.findPricingPanel === "function") {
      panel = window.DrSknnHomepageV2Performance.findPricingPanel(key);
    }
    if (!panel || panel.getAttribute("data-pv3-standardized") === "true") return panel;
    var item = treatmentByKey[key];
    var options = collectCatalogueOptions(panel, key);
    var fallbackUrl = genericBookingUrl(panel);
    var legacy = document.createElement("div");
    var catalogue = document.createElement("section");
    var head = document.createElement("header");
    var eyebrow = document.createElement("span");
    var title = document.createElement("h2");
    var copy = document.createElement("p");
    var controls = document.createElement("div");
    var searchWrap = document.createElement("label");
    var searchLabel = document.createElement("span");
    var search = document.createElement("input");
    var meta = document.createElement("p");
    var groupsWrap = document.createElement("div");
    var showAll = document.createElement("button");
    var guidance = document.createElement("aside");
    var guidanceCopy = document.createElement("div");
    var guidanceTitle = document.createElement("strong");
    var guidanceText = document.createElement("p");
    var guidanceLink = document.createElement("a");
    var serviceTypeChooser = key === "threadingwaxingtinting" ? groomingServiceTypeFilters(options) : null;
    var roles = options.map(function (option) { return option.role; }).filter(function (role, index, list) { return list.indexOf(role) === index; });
    var grouped = groupedCatalogueOptions(options, key);
    var hasDoctor = roles.indexOf("doctor") !== -1;

    legacy.className = "drsknn-pv3-legacy-data";
    legacy.hidden = true;
    legacy.setAttribute("aria-hidden", "true");
    while (panel.firstChild) legacy.appendChild(panel.firstChild);
    panel.appendChild(legacy);

    catalogue.className = "drsknn-pv3-catalogue";
    catalogue.setAttribute("data-pv3-catalogue", key);
    eyebrow.className = "drsknn-pv3-catalogue__eyebrow";
    eyebrow.textContent = "Current published pricing";
    title.textContent = key === "threadingwaxingtinting"
      ? "Choose waxing, threading or tinting"
      : (grouped.length > 1 ? "Choose an area, then a treatment" : "Choose a treatment to explore");
    copy.textContent = key === "threadingwaxingtinting"
      ? "Choose a service type, then select the exact treatment. Appointments are available with our qualified practitioners at Wilmslow and Didsbury."
      : (item ? item.description + " " : "") + (hasDoctor ? "Doctor options appear first. " : "") + "Single, course and subscription prices are shown whenever they are published for that option. Choose an option to continue to its exact booking route.";
    head.className = "drsknn-pv3-catalogue__head";
    head.appendChild(eyebrow);
    head.appendChild(title);
    head.appendChild(copy);

    controls.className = "drsknn-pv3-catalogue__controls";
    searchWrap.className = "drsknn-pv3-catalogue__search";
    searchLabel.textContent = "Search treatment options";
    search.type = "search";
    search.autocomplete = "off";
    search.placeholder = "Search an area or option…";
    search.setAttribute("data-pv3-catalogue-search", "");
    searchWrap.appendChild(searchLabel);
    searchWrap.appendChild(search);
    controls.appendChild(searchWrap);
    if (roles.length > 1) controls.appendChild(catalogueFilters(roles));

    meta.className = "drsknn-pv3-catalogue__meta";
    meta.setAttribute("data-pv3-catalogue-meta", "");
    groupsWrap.className = "drsknn-pv3-catalogue__groups";
    grouped.forEach(function (group, index) { groupsWrap.appendChild(catalogueGroup(group, fallbackUrl, index === 0)); });
    showAll.type = "button";
    showAll.className = "drsknn-pv3-catalogue__show-all";
    showAll.setAttribute("data-pv3-show-all", "");

    guidance.className = "drsknn-pv3-catalogue__guidance";
    guidanceTitle.textContent = "Not sure which exact option is right?";
    guidanceText.textContent = "Consultation fees are shown before you confirm. Where £50 applies, it is a consultation fee with VAT £0. Suitability and your final price are confirmed before treatment.";
    guidanceCopy.appendChild(guidanceTitle);
    guidanceCopy.appendChild(guidanceText);
    guidanceLink.href = fallbackUrl;
    guidanceLink.textContent = "Choose consultation";
    guidanceLink.setAttribute("data-drsknn-booking-link", "");
    guidanceLink.setAttribute("data-drsknn-booking-key", key);
    guidance.appendChild(guidanceCopy);
    guidance.appendChild(guidanceLink);

    if (key === "antiwrinkle") {
      title.textContent = "Anti-Wrinkle Injections";
      copy.textContent = "Compare Doctor and Nurse treatment prices. Your selected areas are carried into a consultation with your chosen clinician; treatment and final prices are confirmed after assessment.";
    }
    catalogue.appendChild(head);
    if (serviceTypeChooser) catalogue.appendChild(serviceTypeChooser);
    catalogue.appendChild(controls);
    catalogue.appendChild(meta);
    catalogue.appendChild(groupsWrap);
    catalogue.appendChild(showAll);
    catalogue.appendChild(guidance);
    if (key === "antiwrinkle") {
      guidanceTitle.textContent = "Discuss your concerns with a doctor";
      guidanceText.textContent = "The consultation is the starting point. Any treatment recommendation and final price depend on an individual assessment.";
      guidanceLink.removeAttribute("data-drsknn-booking-link");
      guidanceLink.removeAttribute("data-drsknn-booking-key");
      guidanceLink.setAttribute("data-pv3-consultation-link", "doctor");
      guidanceLink.textContent = "Book doctor consultation";
    }
    panel.appendChild(catalogue);
    panel.setAttribute("data-pv3-standardized", "true");
    enableCatalogueControls(catalogue);
    return panel;
  }

  function enhanceSelectedTreatment(link) {
    var option = link ? link.closest("[data-pv3-option]") : null;
    if (!option) return;
    var uiModal = link.closest(".drsknn-ui-modal");
    var host = uiModal ? uiModal.querySelector(".drsknn-ui-modal-dialog") || uiModal : link.closest(".drsknn-pricing-modal") || link.closest(".drsknn-pricing-panel");
    var tray = host ? host.querySelector(":scope > .drsknn-pricing-selection-tray:not([hidden])") : null;
    if (!tray) return;

    var title = String(option.getAttribute("data-pv3-option-title") || "Selected treatment").trim();
    var provider = roleLabel(option.getAttribute("data-pv3-option-provider") || "");
    var published = String(option.getAttribute("data-pv3-option-price") || "").trim();
    var summary = tray.querySelector(".drsknn-pv3-selection-summary");
    var titleNode = tray.querySelector(".drsknn-pricing-selection-title");
    var metaNode = tray.querySelector(".drsknn-pricing-selection-meta");

    if (!summary) {
      summary = document.createElement("div");
      summary.className = "drsknn-pv3-selection-summary";
      summary.innerHTML =
        '<p class="drsknn-pv3-selection-label">Treatment selected</p>' +
        '<p class="drsknn-pv3-selection-published"></p>' +
        '<p class="drsknn-pv3-selection-payment">Payment today: shown before confirmation in secure booking.</p>' +
        '<p class="drsknn-pv3-selection-note">Additional treatments are never added automatically. Anything additional is discussed and priced separately first.</p>';
      if (titleNode) summary.insertBefore(titleNode, summary.querySelector(".drsknn-pv3-selection-published"));
      if (metaNode) summary.insertBefore(metaNode, summary.querySelector(".drsknn-pv3-selection-published"));
      tray.insertBefore(summary, tray.firstChild);
    }

    tray.classList.add("drsknn-pricing-selection-tray--v2");
    titleNode = summary.querySelector(".drsknn-pricing-selection-title");
    metaNode = summary.querySelector(".drsknn-pricing-selection-meta");
    if (titleNode) titleNode.textContent = title;
    if (metaNode) metaNode.textContent = "Clinician route: " + provider;
    summary.querySelector(".drsknn-pv3-selection-published").textContent = published ? "Published options: " + published : "Published price: confirmed for this treatment option.";
    tray.setAttribute("aria-label", "Treatment selected: " + title);
  }

  function installSelectedTreatmentEnhancement() {
    var experience = window.DrSknnPricingExperience;
    if (!experience || typeof experience.selectService !== "function" || experience.pricingV3SelectionEnhanced) return;
    var selectService = experience.selectService;
    experience.selectService = function (link) {
      var selected = selectService.call(experience, link);
      if (selected && link && link.hasAttribute("data-pv3-option-link")) enhanceSelectedTreatment(link);
      return selected;
    };
    experience.pricingV3SelectionEnhanced = true;
  }

  function setMode(mode, options) {
    state.mode = mode === "search" ? "search" : "help";
    modeButtons.forEach(function (button) {
      var selected = button.getAttribute("data-pv3-mode") === state.mode;
      button.setAttribute("aria-selected", String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    stages.forEach(function (stage) {
      stage.hidden = stage.getAttribute("data-pv3-stage") !== state.mode;
    });
    if (!options || options.history !== false) {
      hideGuide({ restoreFocus: false });
      state.guideDepth = 0;
      setQuery({
        price_route: state.mode === "search" ? "search" : "",
        area: "",
        concern: "",
        pricing: ""
      }, {
        state: { pv3GuideView: "base", pv3GuideDepth: 0, pv3Area: "", pv3Concern: "" }
      });
    }
    if (state.mode === "search") {
      renderSearch(searchInput.value);
      if (!options || options.focus !== false) window.setTimeout(function () { searchInput.focus(); }, 0);
    }
  }

  function chooseArea(key, trigger, options) {
    state.area = concerns[key] ? key : "";
    guideTriggerArea = state.area;
    var remembered = rememberedConcerns[state.area] || "";
    state.concern = (concerns[state.area] || []).some(function (item) { return item.key === remembered; }) ? remembered : "";
    renderAreas();
    renderConcerns();
    renderResults();
    if (!options || options.history !== false) recordGuideView("concerns", true);
    var currentAreaTrigger = areaGrid.querySelector('[data-pv3-area="' + state.area + '"]') || trigger;
    openGuide("concerns", currentAreaTrigger, options);
  }

  function chooseConcern(key, options) {
    var valid = (concerns[state.area] || []).some(function (item) { return item.key === key; });
    state.concern = valid ? key : "";
    if (state.concern) rememberedConcerns[state.area] = state.concern;
    renderConcerns();
    renderResults();
    if (!options || options.history !== false) recordGuideView("results", true);
    openGuide("results", null, options);
  }

  function openPrice(key, trigger, options) {
    if (!treatmentByKey[key]) return;
    ensureStandardCatalogue(key);
    var source = options && options.source
      ? options.source
      : (trigger && trigger.getAttribute("data-pv3-open-source") === "guide" ? "guide" : "search");
    exactSource = source;
    var showCategories = document.querySelector("[data-pricing-show-categories]");
    if (showCategories) showCategories.textContent = source === "guide" ? "Back to matches" : "All treatments";

    if (!options || options.history !== false) {
      if (source === "guide") {
        var nextDepth = currentGuideDepth() + 1;
        state.guideDepth = nextDepth;
        setQuery({ pricing: key }, {
          push: true,
          state: {
            pv3GuideView: "exact",
            pv3GuideDepth: nextDepth,
            pv3Area: state.area,
            pv3Concern: state.concern,
            pv3ExactSource: "guide"
          }
        });
      } else {
        setQuery({ pricing: key }, {
          state: { pv3GuideView: "base", pv3GuideDepth: 0, pv3ExactSource: "search" }
        });
      }
    }
    if (source === "guide") hideGuide({ restoreFocus: false });
    var original = trigger ? trigger.textContent : "";
    if (trigger) {
      trigger.disabled = true;
      trigger.textContent = "Opening prices…";
    }

    var attempts = 0;
    function attempt() {
      attempts += 1;
      if (typeof window.openDrSknnPricingModal === "function") {
        window.openDrSknnPricingModal(key, trigger || document.activeElement);
        if (trigger) {
          trigger.disabled = false;
          trigger.textContent = original || "See exact prices";
        }
        return;
      }
      if (attempts < 30) {
        window.setTimeout(attempt, 100);
        return;
      }
      if (trigger) {
        trigger.disabled = false;
        trigger.textContent = "Please try again";
      }
      if (source === "guide") openGuide("results", null, { focus: true });
    }
    attempt();
  }

  function closeExactModalSilently() {
    var backdrop = document.getElementById("drsknn-pricing-modal");
    if (!backdrop || !backdrop.classList.contains("drsknn-pricing-modal-open")) return;
    var close = backdrop.querySelector("[data-pricing-close-modal]");
    if (!close) return;
    suppressExactQuerySync = true;
    closeExactModalWithinPricing(close);
    window.setTimeout(function () { suppressExactQuerySync = false; }, 0);
  }

  function closeExactModalWithinPricing(close) {
    if (!close) return;
    close.setAttribute("data-pv3-preserve-pricing-overlay", "true");
    try {
      close.click();
    } finally {
      close.removeAttribute("data-pv3-preserve-pricing-overlay");
    }
  }

  function goBackFromGuide() {
    if (state.guideView !== "results") {
      closeGuide();
      return;
    }
    if (currentGuideDepth() > 0) {
      window.history.back();
      return;
    }
    state.concern = "";
    renderConcerns();
    renderResults();
    recordGuideView("concerns", false);
    showGuideView("concerns");
  }

  function applyLocationState(eventState, options) {
    var params = new URLSearchParams(window.location.search || "");
    if (bookingFinder.active || params.get("open") === "treatment") return;
    var area = params.get("area") || "";
    var concern = params.get("concern") || "";
    var pricing = params.get("pricing") || params.get("pricing_key") || "";
    var validArea = Boolean(concerns[area]);
    var validConcern = validArea && (concerns[area] || []).some(function (item) { return item.key === concern; });

    state.mode = (params.get("price_route") || root.dataset.pricingV3DefaultRoute) === "search" ? "search" : "help";
    state.area = validArea ? area : "";
    state.concern = validConcern ? concern : "";
    state.guideDepth = eventState && Number.isFinite(Number(eventState.pv3GuideDepth)) ? Math.max(0, Number(eventState.pv3GuideDepth)) : 0;
    if (state.concern) rememberedConcerns[state.area] = state.concern;

    renderAreas();
    renderConcerns();
    renderResults();
    setMode(state.mode, { focus: false, history: false });

    if (treatmentByKey[pricing]) {
      var pricingSource = eventState && eventState.pv3ExactSource
        ? eventState.pv3ExactSource
        : (state.area && state.concern ? "guide" : "search");
      hideGuide({ restoreFocus: false });
      openPrice(pricing, null, { history: false, source: pricingSource });
      return;
    }

    closeExactModalSilently();
    exactSource = "";
    if (state.area && state.concern) {
      openGuide("results", null, { focus: !options || options.focus !== false });
    } else if (state.area) {
      openGuide("concerns", null, { focus: !options || options.focus !== false });
    } else {
      hideGuide({ restoreFocus: !options || options.restoreFocus !== false });
    }
  }

  root.addEventListener("click", function (event) {
    if (event.target.closest("[data-pv3-guide-close]")) {
      closeGuide();
      return;
    }
    if (event.target.closest("[data-pv3-guide-back]")) {
      goBackFromGuide();
      return;
    }
    if (event.target.closest("[data-pv3-guide-change-area]")) {
      closeGuide();
      return;
    }
    var areaButton = event.target.closest("[data-pv3-area]");
    if (areaButton) {
      chooseArea(areaButton.getAttribute("data-pv3-area"), areaButton);
      return;
    }
    var concernButton = event.target.closest("[data-pv3-concern]");
    if (concernButton) {
      chooseConcern(concernButton.getAttribute("data-pv3-concern"));
      return;
    }
    var openButton = event.target.closest("[data-pv3-open]");
    if (openButton) openPrice(openButton.getAttribute("data-pv3-open"), openButton);
  });

  if (guide) {
    guide.addEventListener("click", function (event) {
      if (event.target === guide) closeGuide();
    });
  }
  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("[data-pv3-consultation-link]");
    if (!link) return;
    // Preserve normal new-tab/link behavior. The href itself is consultation-only.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!window.openDrSknnContainedBooking(link.href, link)) window.location.href = link.href;
  }, true);

  document.addEventListener("keydown", handleGuideKeydown);
  document.addEventListener("keydown", handleVisitKeydown, true);
  document.addEventListener("keydown", handleBookingFinderKeydown, true);

  modeButtons.forEach(function (button, index) {
    button.addEventListener("click", function () { setMode(button.getAttribute("data-pv3-mode")); });
    button.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      var next = event.key === "ArrowRight" ? (index + 1) % modeButtons.length : (index - 1 + modeButtons.length) % modeButtons.length;
      modeButtons[next].focus();
      modeButtons[next].click();
    });
  });

  searchInput.addEventListener("input", function () { renderSearch(searchInput.value); });

  if ("PointerEvent" in window) {
    document.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "touch" && event.pointerType !== "pen") return;
      beginVisitAddGesture(closestVisitAddButton(event.target), event.pointerId, event.clientX, event.clientY);
    }, true);
    document.addEventListener("pointermove", function (event) {
      if (event.pointerType !== "touch" && event.pointerType !== "pen") return;
      moveVisitAddGesture(event.pointerId, event.clientX, event.clientY);
    }, true);
    document.addEventListener("pointerup", function (event) {
      finishVisitAddGesture(event.pointerId);
    }, true);
    document.addEventListener("pointercancel", function (event) {
      finishVisitAddGesture(event.pointerId);
    }, true);
  } else {
    document.addEventListener("touchstart", function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      var touch = event.changedTouches[0];
      beginVisitAddGesture(closestVisitAddButton(event.target), touch.identifier, touch.clientX, touch.clientY);
    }, { capture: true, passive: true });
    document.addEventListener("touchmove", function (event) {
      if (!visitAddGesture || !event.changedTouches) return;
      Array.prototype.some.call(event.changedTouches, function (touch) {
        if (touch.identifier !== visitAddGesture.pointerId) return false;
        moveVisitAddGesture(touch.identifier, touch.clientX, touch.clientY);
        return true;
      });
    }, { capture: true, passive: true });
    document.addEventListener("touchend", function (event) {
      if (!visitAddGesture || !event.changedTouches) return;
      Array.prototype.some.call(event.changedTouches, function (touch) {
        if (touch.identifier !== visitAddGesture.pointerId) return false;
        finishVisitAddGesture(touch.identifier);
        return true;
      });
    }, true);
    document.addEventListener("touchcancel", function () {
      if (visitAddGesture) finishVisitAddGesture(visitAddGesture.pointerId);
    }, true);
  }

  document.addEventListener("click", function (event) {
    var addToVisit = event.target.closest("[data-pv3-add-visit]");
    if (addToVisit) {
      event.preventDefault();
      if (shouldSuppressVisitAddClick(addToVisit)) {
        event.stopImmediatePropagation();
        return;
      }
      try {
        var selection = JSON.parse(addToVisit.getAttribute("data-pv3-add-visit") || "{}");
        var alreadyAdded = visitSelections.some(function (item) { return item.id === selection.id; });
        if (!alreadyAdded && visitSelections.length >= 10) {
          addToVisit.textContent = "Visit list full";
          showVisitNotice("My visit is full. Remove a treatment before adding another.", "");
          renderVisitBasket(true);
          return;
        }
        if (selection.id && !alreadyAdded) {
          visitSelections.push(selection);
          saveVisitSelections();
        }
        if (alreadyAdded) {
          visitSelections = visitSelections.filter(function (item) { return item.id !== selection.id; });
          saveVisitSelections();
        }
        renderVisitBasket(false);
        if (alreadyAdded) {
          showVisitNotice("“" + selection.title + "” removed from My visit.", "");
        } else {
          showVisitNotice("“" + selection.title + "” added to My visit.", selection.id);
        }
      } catch (_) {}
      return;
    }
    if (event.target.closest("[data-pv3-visit-undo]")) {
      event.preventDefault();
      var undoSelection = visitSelections.find(function (item) { return item.id === visitUndoSelectionId; });
      if (!undoSelection) {
        hideVisitNotice();
        return;
      }
      visitSelections = visitSelections.filter(function (item) { return item.id !== visitUndoSelectionId; });
      saveVisitSelections();
      renderVisitBasket(false);
      showVisitNotice("“" + undoSelection.title + "” removed from My visit.", "");
      return;
    }
    if (event.target.closest("[data-pv3-visit-open]")) {
      event.preventDefault();
      renderVisitBasket(true);
      return;
    }
    if (event.target.closest("[data-pv3-visit-close]")) {
      event.preventDefault();
      closeVisitBasket();
      return;
    }
    var removeFromVisit = event.target.closest("[data-pv3-visit-remove]");
    if (removeFromVisit) {
      event.preventDefault();
      var removeId = removeFromVisit.getAttribute("data-pv3-visit-remove");
      visitSelections = visitSelections.filter(function (item) { return item.id !== removeId; });
      saveVisitSelections();
      renderVisitBasket(true);
      if (!visitSelections.length) closeVisitBasket();
      return;
    }
    if (event.target.closest("[data-pv3-visit-clear]")) {
      event.preventDefault();
      visitSelections = [];
      saveVisitSelections();
      hideVisitNotice();
      renderVisitBasket(false);
      closeVisitBasket();
      return;
    }
    var addVisitConcerns = event.target.closest("[data-pv3-visit-add-concerns]");
    if (addVisitConcerns) {
      event.preventDefault();
      returnToPricingFromVisit("concerns", addVisitConcerns);
      return;
    }
    var addVisitTreatments = event.target.closest("[data-pv3-visit-add-treatments]");
    if (addVisitTreatments) {
      event.preventDefault();
      returnToPricingFromVisit("treatments", addVisitTreatments);
      return;
    }
    var consultationButton = event.target.closest("[data-pv3-visit-consultation]");
    var continueButton = event.target.closest("[data-pv3-visit-continue]") || consultationButton;
    if (continueButton) {
      event.preventDefault();
      if (!visitSelections.length) return;
      var bookingUrl = visitBookingUrl();
      if (!bookingUrl) {
        continueButton.textContent = "Choose the first treatment again";
        return;
      }
      closeVisitBasket();
      if (typeof window.openDrSknnContainedBooking === "function") {
        window.openDrSknnContainedBooking(bookingUrl, continueButton);
      } else {
        window.location.href = bookingUrl;
      }
      return;
    }
    var visitOverlay = event.target.closest("[data-pv3-visit-basket]");
    if (visitOverlay && event.target === visitOverlay) {
      closeVisitBasket();
      return;
    }
    var allTreatments = event.target.closest("[data-pricing-show-categories]");
    if (allTreatments && document.querySelector("[data-drsknn-pricing-v3]")) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var close = document.querySelector("[data-pricing-close-modal]");
      closeExactModalWithinPricing(close);
      if (exactSource === "guide") return;
      setQuery({ pricing: "" });
      exactSource = "";
      setMode("search", { focus: true });
      root.querySelector(".drsknn-pricing-v3__finder").scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    if (event.target.closest("[data-pricing-close-modal]")) {
      window.setTimeout(function () {
        if (bookingFinder.active) return;
        if (suppressExactQuerySync) return;
        if (exactSource === "guide" && window.history.state && window.history.state.pv3GuideView === "exact") {
          window.history.back();
          return;
        }
        setQuery({ pricing: "" }, {
          state: { pv3GuideView: "base", pv3GuideDepth: 0, pv3ExactSource: "" }
        });
        exactSource = "";
      }, 0);
    }
  }, true);

  window.addEventListener("popstate", function (event) {
    var finderState = bookingFinderHistoryView(event.state);
    if (bookingFinder.active || finderState) {
      var returnFromBooking = bookingFinder.active && bookingFinder.suspended && !finderState;
      var activeBooking = document.querySelector("[data-drsknn-landing-modal].is-open");
      if (activeBooking) {
        var bookingClose = activeBooking.querySelector("[data-drsknn-landing-modal-close]");
        if (bookingClose) bookingClose.click();
      }
      if (returnFromBooking) {
        // A parent Back from the calendar returns to its chooser. Explicit
        // Close/embedded Back never traverse history and resume directly.
        window.history.pushState(Object.assign({}, event.state || {}, { pv3BookingFinder: "finder" }), "", bookingFinder.resumeUrl);
        bookingFinder.pushed = true;
        resumeBookingFinder();
      } else if (finderState) {
        // Forward navigation restores the chooser; an old iframe is never replayed.
        if (finderState === "booking") window.history.replaceState(Object.assign({}, event.state, { pv3BookingFinder: "finder" }), "", window.location.href);
        if (bookingFinder.active) resumeBookingFinder();
        else openBookingFinder(null, true);
      } else finishBookingFinder();
      return;
    }
    var visitOverlay = document.querySelector("[data-pv3-visit-basket]");
    if (visitOverlay && !visitOverlay.hidden) closeVisitBasket({ restoreFocus: false });
    applyLocationState(event.state || {}, { focus: true, restoreFocus: true });
  });

  installSelectedTreatmentEnhancement();
  renderAreas();
  renderConcerns();
  renderResults();
  renderSearch("");
  renderVisitBasket(false);
  renderBookingReturnNotice();

  try {
    var params = new URLSearchParams(window.location.search || "");
    var initialArea = params.get("area") || "";
    var initialConcern = params.get("concern") || "";
    var initialPricing = params.get("pricing") || params.get("pricing_key") || "";
    var validInitialArea = Boolean(concerns[initialArea]);
    var validInitialConcern = validInitialArea && (concerns[initialArea] || []).some(function (item) { return item.key === initialConcern; });
    var initialView = treatmentByKey[initialPricing]
      ? "exact"
      : (validInitialConcern ? "results" : (validInitialArea ? "concerns" : "base"));
    var initialState = Object.assign({}, window.history.state || {}, {
      pv3GuideView: initialView,
      pv3GuideDepth: 0,
      pv3Area: validInitialArea ? initialArea : "",
      pv3Concern: validInitialConcern ? initialConcern : "",
      pv3ExactSource: initialView === "exact" && validInitialConcern ? "guide" : "search"
    });
    window.history.replaceState(initialState, "", window.location.href);
    window.setTimeout(function () { applyLocationState(initialState, { focus: false, restoreFocus: false }); }, 80);
  } catch (_) {
    setMode("help", { focus: false, history: false });
  }

  window.DrSknnPricingV3 = {
    supportsHomepagePanelCache: true,
    openBookingFinder: openBookingFinder,
    openPrice: openPrice,
    standardize: ensureStandardCatalogue,
    standardizeAll: function () {
      treatments.forEach(function (item) { ensureStandardCatalogue(item.key); });
    },
    openGuide: function (area, concern) {
      if (!concerns[area]) return false;
      state.area = area;
      state.concern = (concerns[area] || []).some(function (item) { return item.key === concern; }) ? concern : "";
      renderAreas();
      renderConcerns();
      renderResults();
      openGuide(state.concern ? "results" : "concerns", null, { focus: true });
      return true;
    },
    treatmentCount: treatments.length,
    version: "3.4.0"
  };
  window.DrSknnPricingV2 = window.DrSknnPricingV3;
})();
